//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param idFrontFile (optional) 
     * @param idBackFile (optional) 
     * @param selfieFile (optional) 
     * @param verificationIdType (optional) 
     * @return OK
     */
    uploadAcademyIDFile(idFrontFile?: FileParameter | undefined, idBackFile?: FileParameter | undefined, selfieFile?: FileParameter | undefined, verificationIdType?: VerificationIdTypeEnum | undefined, signal?: AbortSignal): Promise<AcademyProfileModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Academy/uploadAcademyIDFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (idFrontFile !== null && idFrontFile !== undefined)
            content_.append("IdFrontFile", idFrontFile.data, idFrontFile.fileName ? idFrontFile.fileName : "IdFrontFile");
        if (idBackFile !== null && idBackFile !== undefined)
            content_.append("IdBackFile", idBackFile.data, idBackFile.fileName ? idBackFile.fileName : "IdBackFile");
        if (selfieFile !== null && selfieFile !== undefined)
            content_.append("SelfieFile", selfieFile.data, selfieFile.fileName ? selfieFile.fileName : "SelfieFile");
        if (verificationIdType === null || verificationIdType === undefined)
            throw new Error("The parameter 'verificationIdType' cannot be null.");
        else
            content_.append("VerificationIdType", verificationIdType.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadAcademyIDFile(_response);
        });
    }

    protected processUploadAcademyIDFile(response: Response): Promise<AcademyProfileModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AcademyProfileModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcademyProfileModelRestApiResponse>(null as any);
    }

    /**
     * @param monthsBack (optional) 
     * @return OK
     */
    getReports(monthsBack?: number | undefined, signal?: AbortSignal): Promise<AcademyReportsModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Academy/GetReports?";
        if (monthsBack === null)
            throw new Error("The parameter 'monthsBack' cannot be null.");
        else if (monthsBack !== undefined)
            url_ += "monthsBack=" + encodeURIComponent("" + monthsBack) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReports(_response);
        });
    }

    protected processGetReports(response: Response): Promise<AcademyReportsModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AcademyReportsModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcademyReportsModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAcademyProfile(token: string, signal?: AbortSignal): Promise<AcademyProfileModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Academy/GetAcademyProfile/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAcademyProfile(_response);
        });
    }

    protected processGetAcademyProfile(response: Response): Promise<AcademyProfileModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AcademyProfileModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcademyProfileModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAcademyTutors(signal?: AbortSignal): Promise<TutorSummaryModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Academy/GetAcademyTutors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAcademyTutors(_response);
        });
    }

    protected processGetAcademyTutors(response: Response): Promise<TutorSummaryModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorSummaryModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorSummaryModelIListRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addAcademyTutor(body?: AddAcademyTutorRequest | undefined, signal?: AbortSignal): Promise<TutorSummaryModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Academy/AddAcademyTutor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAcademyTutor(_response);
        });
    }

    protected processAddAcademyTutor(response: Response): Promise<TutorSummaryModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorSummaryModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorSummaryModelRestApiResponse>(null as any);
    }

    /**
     * @param tutorToken (optional) 
     * @return OK
     */
    toggleTutorActive(tutorToken?: string | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Academy/ToggleTutorActive?";
        if (tutorToken === null)
            throw new Error("The parameter 'tutorToken' cannot be null.");
        else if (tutorToken !== undefined)
            url_ += "tutorToken=" + encodeURIComponent("" + tutorToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleTutorActive(_response);
        });
    }

    protected processToggleTutorActive(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param tutorToken (optional) 
     * @return OK
     */
    resetTutorPassword(tutorToken?: string | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Academy/ResetTutorPassword?";
        if (tutorToken === null)
            throw new Error("The parameter 'tutorToken' cannot be null.");
        else if (tutorToken !== undefined)
            url_ += "tutorToken=" + encodeURIComponent("" + tutorToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetTutorPassword(_response);
        });
    }

    protected processResetTutorPassword(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    verificationList(signal?: AbortSignal): Promise<any[]> {
        let url_ = this.baseUrl + "/api/Admin/VerificationList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerificationList(_response);
        });
    }

    protected processVerificationList(response: Response): Promise<any[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as any[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any[]>(null as any);
    }

    /**
     * @param userToken (optional) 
     * @param isVerified (optional) 
     * @param rejectionReason (optional) 
     * @return OK
     */
    updateVerificationStatus(userToken?: string | undefined, isVerified?: boolean | undefined, rejectionReason?: string | undefined, signal?: AbortSignal): Promise<UserModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Admin/UpdateVerificationStatus?";
        if (userToken === null)
            throw new Error("The parameter 'userToken' cannot be null.");
        else if (userToken !== undefined)
            url_ += "userToken=" + encodeURIComponent("" + userToken) + "&";
        if (isVerified === null)
            throw new Error("The parameter 'isVerified' cannot be null.");
        else if (isVerified !== undefined)
            url_ += "isVerified=" + encodeURIComponent("" + isVerified) + "&";
        if (rejectionReason === null)
            throw new Error("The parameter 'rejectionReason' cannot be null.");
        else if (rejectionReason !== undefined)
            url_ += "rejectionReason=" + encodeURIComponent("" + rejectionReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateVerificationStatus(_response);
        });
    }

    protected processUpdateVerificationStatus(response: Response): Promise<UserModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as UserModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    users(signal?: AbortSignal): Promise<AccountInfoModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Admin/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsers(_response);
        });
    }

    protected processUsers(response: Response): Promise<AccountInfoModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModelIListRestApiResponse>(null as any);
    }

    /**
     * @param take (optional) 
     * @return OK
     */
    calls(take?: number | undefined, signal?: AbortSignal): Promise<VoiceCallSummaryModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Admin/Calls?";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalls(_response);
        });
    }

    protected processCalls(response: Response): Promise<VoiceCallSummaryModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as VoiceCallSummaryModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceCallSummaryModelIListRestApiResponse>(null as any);
    }

    /**
     * @param userToken (optional) 
     * @param isVerified (optional) 
     * @return OK
     */
    setUserVerifiedStatus(userToken?: string | undefined, isVerified?: boolean | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Admin/SetUserVerifiedStatus?";
        if (userToken === null)
            throw new Error("The parameter 'userToken' cannot be null.");
        else if (userToken !== undefined)
            url_ += "userToken=" + encodeURIComponent("" + userToken) + "&";
        if (isVerified === null)
            throw new Error("The parameter 'isVerified' cannot be null.");
        else if (isVerified !== undefined)
            url_ += "isVerified=" + encodeURIComponent("" + isVerified) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUserVerifiedStatus(_response);
        });
    }

    protected processSetUserVerifiedStatus(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    impersonateUser(email?: string | undefined, signal?: AbortSignal): Promise<AccountInfoModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Admin/ImpersonateUser?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImpersonateUser(_response);
        });
    }

    protected processImpersonateUser(response: Response): Promise<AccountInfoModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendMarketingEmail(body?: MarketingEmailRequest | undefined, signal?: AbortSignal): Promise<MarketingEmailResultRestApiResponse> {
        let url_ = this.baseUrl + "/api/Admin/SendMarketingEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMarketingEmail(_response);
        });
    }

    protected processSendMarketingEmail(response: Response): Promise<MarketingEmailResultRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MarketingEmailResultRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingEmailResultRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendMarketingWhatsApp(body?: MarketingWhatsAppRequest | undefined, signal?: AbortSignal): Promise<MarketingWhatsAppResultRestApiResponse> {
        let url_ = this.baseUrl + "/api/Admin/SendMarketingWhatsApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMarketingWhatsApp(_response);
        });
    }

    protected processSendMarketingWhatsApp(response: Response): Promise<MarketingWhatsAppResultRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MarketingWhatsAppResultRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingWhatsAppResultRestApiResponse>(null as any);
    }

    /**
     * @param lectureToken (optional) 
     * @return OK
     */
    agoratoken(lectureToken?: string | undefined, signal?: AbortSignal): Promise<AgoraAccessTokenObjRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/Agoratoken?";
        if (lectureToken === null)
            throw new Error("The parameter 'lectureToken' cannot be null.");
        else if (lectureToken !== undefined)
            url_ += "LectureToken=" + encodeURIComponent("" + lectureToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAgoratoken(_response);
        });
    }

    protected processAgoratoken(response: Response): Promise<AgoraAccessTokenObjRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AgoraAccessTokenObjRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgoraAccessTokenObjRestApiResponse>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @return OK
     */
    participants(channelName?: string | undefined, signal?: AbortSignal): Promise<AgoraParticipantDtoListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/participants?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processParticipants(_response);
        });
    }

    protected processParticipants(response: Response): Promise<AgoraParticipantDtoListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AgoraParticipantDtoListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgoraParticipantDtoListRestApiResponse>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @return OK
     */
    status(channelName?: string | undefined, signal?: AbortSignal): Promise<AgoraParticipantDtoRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/status?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: Response): Promise<AgoraParticipantDtoRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AgoraParticipantDtoRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgoraParticipantDtoRestApiResponse>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @return OK
     */
    leave(channelName?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Agora/leave?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLeave(_response);
        });
    }

    protected processLeave(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @param targetUid (optional) 
     * @return OK
     */
    kickParticipant(channelName?: string | undefined, targetUid?: number | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/kickParticipant?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        if (targetUid === null)
            throw new Error("The parameter 'targetUid' cannot be null.");
        else if (targetUid !== undefined)
            url_ += "targetUid=" + encodeURIComponent("" + targetUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKickParticipant(_response);
        });
    }

    protected processKickParticipant(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @param targetUid (optional) 
     * @return OK
     */
    toggleMuteLock(channelName?: string | undefined, targetUid?: number | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/toggle-mute-lock?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        if (targetUid === null)
            throw new Error("The parameter 'targetUid' cannot be null.");
        else if (targetUid !== undefined)
            url_ += "targetUid=" + encodeURIComponent("" + targetUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleMuteLock(_response);
        });
    }

    protected processToggleMuteLock(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @param targetUid (optional) 
     * @return OK
     */
    toggleCameraLock(channelName?: string | undefined, targetUid?: number | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/toggle-camera-lock?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        if (targetUid === null)
            throw new Error("The parameter 'targetUid' cannot be null.");
        else if (targetUid !== undefined)
            url_ += "targetUid=" + encodeURIComponent("" + targetUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleCameraLock(_response);
        });
    }

    protected processToggleCameraLock(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @param screenUid (optional) 
     * @return OK
     */
    registerScreen(channelName?: string | undefined, screenUid?: number | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/register-screen?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        if (screenUid === null)
            throw new Error("The parameter 'screenUid' cannot be null.");
        else if (screenUid !== undefined)
            url_ += "screenUid=" + encodeURIComponent("" + screenUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterScreen(_response);
        });
    }

    protected processRegisterScreen(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param channelName (optional) 
     * @return OK
     */
    unregisterScreen(channelName?: string | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Agora/unregister-screen?";
        if (channelName === null)
            throw new Error("The parameter 'channelName' cannot be null.");
        else if (channelName !== undefined)
            url_ += "channelName=" + encodeURIComponent("" + channelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnregisterScreen(_response);
        });
    }

    protected processUnregisterScreen(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendAssistantMessage(body?: AiChatRequest | undefined, signal?: AbortSignal): Promise<AiChatResponseRestApiResponse> {
        let url_ = this.baseUrl + "/api/AiAssistant/sendAssistantMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendAssistantMessage(_response);
        });
    }

    protected processSendAssistantMessage(response: Response): Promise<AiChatResponseRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AiChatResponseRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiChatResponseRestApiResponse>(null as any);
    }

    /**
     * @param assessmentJson (optional) 
     * @param promptPdfFile (optional) 
     * @return OK
     */
    saveAssessment(assessmentJson?: string | undefined, promptPdfFile?: FileParameter | undefined, signal?: AbortSignal): Promise<AssessmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/saveAssessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (assessmentJson === null || assessmentJson === undefined)
            throw new Error("The parameter 'assessmentJson' cannot be null.");
        else
            content_.append("AssessmentJson", assessmentJson.toString());
        if (promptPdfFile !== null && promptPdfFile !== undefined)
            content_.append("PromptPdfFile", promptPdfFile.data, promptPdfFile.fileName ? promptPdfFile.fileName : "PromptPdfFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAssessment(_response);
        });
    }

    protected processSaveAssessment(response: Response): Promise<AssessmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentModelRestApiResponse>(null as any);
    }

    /**
     * @param assessmentType (optional) 
     * @return OK
     */
    initAssessmentForm(assessmentType?: AssessmentTypeEnum | undefined, signal?: AbortSignal): Promise<AssessmentSaveRequest> {
        let url_ = this.baseUrl + "/api/Assessment/initAssessmentForm?";
        if (assessmentType === null)
            throw new Error("The parameter 'assessmentType' cannot be null.");
        else if (assessmentType !== undefined)
            url_ += "assessmentType=" + encodeURIComponent("" + assessmentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitAssessmentForm(_response);
        });
    }

    protected processInitAssessmentForm(response: Response): Promise<AssessmentSaveRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentSaveRequest;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentSaveRequest>(null as any);
    }

    /**
     * @return OK
     */
    deleteAssessment(assessmentToken: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/DeleteAssessment/{assessmentToken}";
        if (assessmentToken === undefined || assessmentToken === null)
            throw new Error("The parameter 'assessmentToken' must be defined.");
        url_ = url_.replace("{assessmentToken}", encodeURIComponent("" + assessmentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssessment(_response);
        });
    }

    protected processDeleteAssessment(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    exams(courseToken: string, signal?: AbortSignal): Promise<AssessmentModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/course/{courseToken}/exams";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExams(_response);
        });
    }

    protected processExams(response: Response): Promise<AssessmentModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    homeworks(lectureToken: string, signal?: AbortSignal): Promise<AssessmentModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/lecture/{lectureToken}/homeworks";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHomeworks(_response);
        });
    }

    protected processHomeworks(response: Response): Promise<AssessmentModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    assessmentDetail(assessmentToken: string, signal?: AbortSignal): Promise<AssessmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/AssessmentDetail/{assessmentToken}";
        if (assessmentToken === undefined || assessmentToken === null)
            throw new Error("The parameter 'assessmentToken' must be defined.");
        url_ = url_.replace("{assessmentToken}", encodeURIComponent("" + assessmentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentDetail(_response);
        });
    }

    protected processAssessmentDetail(response: Response): Promise<AssessmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    eligibleStudents(courseToken: string, signal?: AbortSignal): Promise<AssessmentStudentModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/course/{courseToken}/eligible-students";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEligibleStudents(_response);
        });
    }

    protected processEligibleStudents(response: Response): Promise<AssessmentStudentModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentStudentModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentStudentModelIListRestApiResponse>(null as any);
    }

    /**
     * @param answersJson (optional) 
     * @param fileQuestionIds (optional) 
     * @param files (optional) 
     * @return OK
     */
    submitAssessment(assessmentToken: string, answersJson?: string | undefined, fileQuestionIds?: string[] | undefined, files?: FileParameter[] | undefined, signal?: AbortSignal): Promise<AssessmentSubmissionModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/{assessmentToken}/submit-assessment";
        if (assessmentToken === undefined || assessmentToken === null)
            throw new Error("The parameter 'assessmentToken' must be defined.");
        url_ = url_.replace("{assessmentToken}", encodeURIComponent("" + assessmentToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (answersJson === null || answersJson === undefined)
            throw new Error("The parameter 'answersJson' cannot be null.");
        else
            content_.append("AnswersJson", answersJson.toString());
        if (fileQuestionIds === null || fileQuestionIds === undefined)
            throw new Error("The parameter 'fileQuestionIds' cannot be null.");
        else
            fileQuestionIds.forEach(item_ => content_.append("fileQuestionIds", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitAssessment(_response);
        });
    }

    protected processSubmitAssessment(response: Response): Promise<AssessmentSubmissionModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentSubmissionModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentSubmissionModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    myAssessmentSubmission(assessmentToken: string, signal?: AbortSignal): Promise<AssessmentSubmissionModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/{assessmentToken}/my-assessment-submission";
        if (assessmentToken === undefined || assessmentToken === null)
            throw new Error("The parameter 'assessmentToken' must be defined.");
        url_ = url_.replace("{assessmentToken}", encodeURIComponent("" + assessmentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyAssessmentSubmission(_response);
        });
    }

    protected processMyAssessmentSubmission(response: Response): Promise<AssessmentSubmissionModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentSubmissionModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentSubmissionModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    assessmentSubmissions(assessmentToken: string, signal?: AbortSignal): Promise<AssessmentSubmissionModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/{assessmentToken}/assessment-submissions";
        if (assessmentToken === undefined || assessmentToken === null)
            throw new Error("The parameter 'assessmentToken' must be defined.");
        url_ = url_.replace("{assessmentToken}", encodeURIComponent("" + assessmentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentSubmissions(_response);
        });
    }

    protected processAssessmentSubmissions(response: Response): Promise<AssessmentSubmissionModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentSubmissionModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentSubmissionModelIListRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    grade(assessmentToken: string, studentToken: string, body?: GradeAssessmentSubmissionRequest | undefined, signal?: AbortSignal): Promise<AssessmentSubmissionModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/{assessmentToken}/assessment-submissions/{studentToken}/grade";
        if (assessmentToken === undefined || assessmentToken === null)
            throw new Error("The parameter 'assessmentToken' must be defined.");
        url_ = url_.replace("{assessmentToken}", encodeURIComponent("" + assessmentToken));
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGrade(_response);
        });
    }

    protected processGrade(response: Response): Promise<AssessmentSubmissionModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentSubmissionModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentSubmissionModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    myPendingAssessments(signal?: AbortSignal): Promise<PendingAssessmentModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/my-pending-assessments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyPendingAssessments(_response);
        });
    }

    protected processMyPendingAssessments(response: Response): Promise<PendingAssessmentModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PendingAssessmentModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PendingAssessmentModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    assessmentExamReport(studentToken: string, signal?: AbortSignal): Promise<AssessmentReportItemModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/student/{studentToken}/AssessmentExamReport";
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentExamReport(_response);
        });
    }

    protected processAssessmentExamReport(response: Response): Promise<AssessmentReportItemModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentReportItemModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentReportItemModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    assessmentHomeworkReport(studentToken: string, signal?: AbortSignal): Promise<AssessmentReportItemModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Assessment/student/{studentToken}/AssessmentHomeworkReport";
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentHomeworkReport(_response);
        });
    }

    protected processAssessmentHomeworkReport(response: Response): Promise<AssessmentReportItemModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentReportItemModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentReportItemModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    categories(signal?: AbortSignal): Promise<CategoryModel[]> {
        let url_ = this.baseUrl + "/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories(_response);
        });
    }

    protected processCategories(response: Response): Promise<CategoryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CategoryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    issueCertificate(body?: IssueCertificateRequest | undefined, signal?: AbortSignal): Promise<CertificateModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Certificate/issueCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIssueCertificate(_response);
        });
    }

    protected processIssueCertificate(response: Response): Promise<CertificateModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CertificateModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    issuedCertificate(certificateToken: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Certificate/issued-certificate/{certificateToken}";
        if (certificateToken === undefined || certificateToken === null)
            throw new Error("The parameter 'certificateToken' must be defined.");
        url_ = url_.replace("{certificateToken}", encodeURIComponent("" + certificateToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIssuedCertificate(_response);
        });
    }

    protected processIssuedCertificate(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    certificateEligibleStudents(courseToken: string, signal?: AbortSignal): Promise<AssessmentStudentModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Certificate/course/{courseToken}/certificate-eligible-students";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCertificateEligibleStudents(_response);
        });
    }

    protected processCertificateEligibleStudents(response: Response): Promise<AssessmentStudentModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AssessmentStudentModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentStudentModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    issuedCertificates(courseToken: string, signal?: AbortSignal): Promise<CertificateModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Certificate/course/{courseToken}/issued-certificates";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIssuedCertificates(_response);
        });
    }

    protected processIssuedCertificates(response: Response): Promise<CertificateModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CertificateModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    myCertificates(signal?: AbortSignal): Promise<CertificateModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Certificate/my-certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyCertificates(_response);
        });
    }

    protected processMyCertificates(response: Response): Promise<CertificateModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CertificateModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    certificates(childToken: string, signal?: AbortSignal): Promise<CertificateModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Certificate/child/{childToken}/certificates";
        if (childToken === undefined || childToken === null)
            throw new Error("The parameter 'childToken' must be defined.");
        url_ = url_.replace("{childToken}", encodeURIComponent("" + childToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCertificates(_response);
        });
    }

    protected processCertificates(response: Response): Promise<CertificateModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CertificateModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    certificate(certificateToken: string, signal?: AbortSignal): Promise<CertificateModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Certificate/public/certificate/{certificateToken}";
        if (certificateToken === undefined || certificateToken === null)
            throw new Error("The parameter 'certificateToken' must be defined.");
        url_ = url_.replace("{certificateToken}", encodeURIComponent("" + certificateToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCertificate(_response);
        });
    }

    protected processCertificate(response: Response): Promise<CertificateModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CertificateModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    pdf(certificateToken: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Certificate/public/certificate/{certificateToken}/pdf";
        if (certificateToken === undefined || certificateToken === null)
            throw new Error("The parameter 'certificateToken' must be defined.");
        url_ = url_.replace("{certificateToken}", encodeURIComponent("" + certificateToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPdf(_response);
        });
    }

    protected processPdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    contact(body?: ContactFormRequest | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Common/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContact(_response);
        });
    }

    protected processContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    siteStatus(signal?: AbortSignal): Promise<SiteStatusModel> {
        let url_ = this.baseUrl + "/api/Common/site-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSiteStatus(_response);
        });
    }

    protected processSiteStatus(response: Response): Promise<SiteStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as SiteStatusModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteStatusModel>(null as any);
    }

    /**
     * @return OK
     */
    dashBoardSummary(signal?: AbortSignal): Promise<DashBoardSummaryModel> {
        let url_ = this.baseUrl + "/api/Common/dashBoardSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashBoardSummary(_response);
        });
    }

    protected processDashBoardSummary(response: Response): Promise<DashBoardSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as DashBoardSummaryModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashBoardSummaryModel>(null as any);
    }

    /**
     * @return OK
     */
    favouritesCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Common/dashboard/count/favourites-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFavouritesCount(_response);
        });
    }

    protected processFavouritesCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    followingCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Common/dashboard/count/following-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFollowingCount(_response);
        });
    }

    protected processFollowingCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    ownCoursesCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Common/dashboard/count/own-courses-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOwnCoursesCount(_response);
        });
    }

    protected processOwnCoursesCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    enrolledLecturesCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Common/dashboard/count/enrolled-lectures-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnrolledLecturesCount(_response);
        });
    }

    protected processEnrolledLecturesCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    teachingLecturesCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Common/dashboard/count/teaching-lectures-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTeachingLecturesCount(_response);
        });
    }

    protected processTeachingLecturesCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    joinRequestsCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Common/dashboard/count/join-requests-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJoinRequestsCount(_response);
        });
    }

    protected processJoinRequestsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    pendingExamsCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Common/dashboard/count/pending-exams-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPendingExamsCount(_response);
        });
    }

    protected processPendingExamsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    currencies(signal?: AbortSignal): Promise<CurrencyModel[]> {
        let url_ = this.baseUrl + "/api/Common/currencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrencies(_response);
        });
    }

    protected processCurrencies(response: Response): Promise<CurrencyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CurrencyModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyModel[]>(null as any);
    }

    /**
     * @return OK
     */
    languages(signal?: AbortSignal): Promise<LanguageModel[]> {
        let url_ = this.baseUrl + "/api/Common/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLanguages(_response);
        });
    }

    protected processLanguages(response: Response): Promise<LanguageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LanguageModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageModel[]>(null as any);
    }

    /**
     * @return OK
     */
    countries(signal?: AbortSignal): Promise<CountryModel[]> {
        let url_ = this.baseUrl + "/api/Common/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCountries(_response);
        });
    }

    protected processCountries(response: Response): Promise<CountryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CountryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryModel[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param maxcount (optional) 
     * @param types (optional) 
     * @return OK
     */
    search(keyword?: string | undefined, maxcount?: number | undefined, types?: ItemTypeEnum[] | undefined, signal?: AbortSignal): Promise<SearchResultItemModel[]> {
        let url_ = this.baseUrl + "/api/Common/search?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxcount === null)
            throw new Error("The parameter 'maxcount' cannot be null.");
        else if (maxcount !== undefined)
            url_ += "maxcount=" + encodeURIComponent("" + maxcount) + "&";
        if (types === null)
            throw new Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SearchResultItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as SearchResultItemModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResultItemModel[]>(null as any);
    }

    /**
     * @return OK
     */
    exportLink(blobName: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/Common/export-link/{blobName}";
        if (blobName === undefined || blobName === null)
            throw new Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportLink(_response);
        });
    }

    protected processExportLink(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getCourseSummaryByToken(token: string, signal?: AbortSignal): Promise<CourseSummaryModel> {
        let url_ = this.baseUrl + "/api/Courses/GetCourseSummaryByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCourseSummaryByToken(_response);
        });
    }

    protected processGetCourseSummaryByToken(response: Response): Promise<CourseSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseSummaryModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSummaryModel>(null as any);
    }

    /**
     * @return OK
     */
    initCourseFormByToken(token: string, signal?: AbortSignal): Promise<CourseSaveRequest> {
        let url_ = this.baseUrl + "/api/Courses/InitCourseFormByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitCourseFormByToken(_response);
        });
    }

    protected processInitCourseFormByToken(response: Response): Promise<CourseSaveRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseSaveRequest;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSaveRequest>(null as any);
    }

    /**
     * @return OK
     */
    getCourseByToken(token: string, signal?: AbortSignal): Promise<CourseGraphModel> {
        let url_ = this.baseUrl + "/api/Courses/GetCourseByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCourseByToken(_response);
        });
    }

    protected processGetCourseByToken(response: Response): Promise<CourseGraphModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseGraphModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGraphModel>(null as any);
    }

    /**
     * @return OK
     */
    getRecentCoursesList(count: number, signal?: AbortSignal): Promise<CourseSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Courses/GetRecentCoursesList/{count}";
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecentCoursesList(_response);
        });
    }

    protected processGetRecentCoursesList(response: Response): Promise<CourseSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    myCoursesList(signal?: AbortSignal): Promise<CourseSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Courses/MyCoursesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyCoursesList(_response);
        });
    }

    protected processMyCoursesList(response: Response): Promise<CourseSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    favoriteCoursesList(signal?: AbortSignal): Promise<CourseSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Courses/FavoriteCoursesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFavoriteCoursesList(_response);
        });
    }

    protected processFavoriteCoursesList(response: Response): Promise<CourseSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    ownCoursesList(signal?: AbortSignal): Promise<CourseSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Courses/OwnCoursesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOwnCoursesList(_response);
        });
    }

    protected processOwnCoursesList(response: Response): Promise<CourseSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    ownedOrAuthoredCoursesList(signal?: AbortSignal): Promise<CourseSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Courses/OwnedOrAuthoredCoursesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOwnedOrAuthoredCoursesList(_response);
        });
    }

    protected processOwnedOrAuthoredCoursesList(response: Response): Promise<CourseSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseSummaryModel[]>(null as any);
    }

    /**
     * @param courseToken (optional) 
     * @return OK
     */
    toggleFavoriteCourse(courseToken?: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Courses/ToggleFavoriteCourse?";
        if (courseToken === null)
            throw new Error("The parameter 'courseToken' cannot be null.");
        else if (courseToken !== undefined)
            url_ += "courseToken=" + encodeURIComponent("" + courseToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleFavoriteCourse(_response);
        });
    }

    protected processToggleFavoriteCourse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param courseJson (optional) 
     * @param introVideoFile (optional) 
     * @param pdfFile (optional) 
     * @param imageFile (optional) 
     * @return OK
     */
    saveCourse(courseJson?: string | undefined, introVideoFile?: FileParameter | undefined, pdfFile?: FileParameter | undefined, imageFile?: FileParameter | undefined, signal?: AbortSignal): Promise<CourseGraphModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Courses/SaveCourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (courseJson === null || courseJson === undefined)
            throw new Error("The parameter 'courseJson' cannot be null.");
        else
            content_.append("CourseJson", courseJson.toString());
        if (introVideoFile !== null && introVideoFile !== undefined)
            content_.append("IntroVideoFile", introVideoFile.data, introVideoFile.fileName ? introVideoFile.fileName : "IntroVideoFile");
        if (pdfFile !== null && pdfFile !== undefined)
            content_.append("PdfFile", pdfFile.data, pdfFile.fileName ? pdfFile.fileName : "PdfFile");
        if (imageFile !== null && imageFile !== undefined)
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCourse(_response);
        });
    }

    protected processSaveCourse(response: Response): Promise<CourseGraphModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CourseGraphModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CourseGraphModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteCourse(token: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Courses/DeleteCourse/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCourse(_response);
        });
    }

    protected processDeleteCourse(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSummary(signal?: AbortSignal): Promise<DashboardSummaryDetailModel> {
        let url_ = this.baseUrl + "/api/DashboardSummary/getSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: Response): Promise<DashboardSummaryDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as DashboardSummaryDetailModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardSummaryDetailModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submit(body?: SubmitFeedbackRequest | undefined, signal?: AbortSignal): Promise<FeedbackDtoRestApiResponse> {
        let url_ = this.baseUrl + "/api/Feedback/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<FeedbackDtoRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as FeedbackDtoRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedbackDtoRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    my(signal?: AbortSignal): Promise<FeedbackDtoListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Feedback/my";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMy(_response);
        });
    }

    protected processMy(response: Response): Promise<FeedbackDtoListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as FeedbackDtoListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedbackDtoListRestApiResponse>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    all(page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<FeedbackDtoListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Feedback/all?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<FeedbackDtoListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as FeedbackDtoListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedbackDtoListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    stats(signal?: AbortSignal): Promise<FeedbackStatsDtoRestApiResponse> {
        let url_ = this.baseUrl + "/api/Feedback/stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStats(_response);
        });
    }

    protected processStats(response: Response): Promise<FeedbackStatsDtoRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as FeedbackStatsDtoRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeedbackStatsDtoRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    student(lectureToken: string, studentToken: string, body?: CreateInvoiceRequest | undefined, signal?: AbortSignal): Promise<InvoiceModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/lecture/{lectureToken}/student/{studentToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudent(_response);
        });
    }

    protected processStudent(response: Response): Promise<InvoiceModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as InvoiceModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    paypalRecipients(lectureToken: string, signal?: AbortSignal): Promise<PaypalRecipientCandidateModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/lecture/{lectureToken}/paypal-recipients";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaypalRecipients(_response);
        });
    }

    protected processPaypalRecipients(response: Response): Promise<PaypalRecipientCandidateModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PaypalRecipientCandidateModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaypalRecipientCandidateModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    list(lectureToken: string, signal?: AbortSignal): Promise<InvoiceModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/lecture/{lectureToken}/list";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<InvoiceModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as InvoiceModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    list2(studentToken: string, signal?: AbortSignal): Promise<InvoiceModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/student/{studentToken}/list";
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList2(_response);
        });
    }

    protected processList2(response: Response): Promise<InvoiceModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as InvoiceModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    forTutor(studentToken: string, signal?: AbortSignal): Promise<InvoiceModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/student/{studentToken}/for-tutor";
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForTutor(_response);
        });
    }

    protected processForTutor(response: Response): Promise<InvoiceModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as InvoiceModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionsForTutor(studentToken: string, signal?: AbortSignal): Promise<SubscriptionEntryModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/student/{studentToken}/subscriptions-for-tutor";
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriptionsForTutor(_response);
        });
    }

    protected processSubscriptionsForTutor(response: Response): Promise<SubscriptionEntryModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as SubscriptionEntryModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionEntryModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    subscriptions(lectureToken: string, signal?: AbortSignal): Promise<SubscriptionEntryModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/lecture/{lectureToken}/subscriptions";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriptions(_response);
        });
    }

    protected processSubscriptions(response: Response): Promise<SubscriptionEntryModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as SubscriptionEntryModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionEntryModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    mySentInvoices(signal?: AbortSignal): Promise<InvoiceModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/my-sent-invoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMySentInvoices(_response);
        });
    }

    protected processMySentInvoices(response: Response): Promise<InvoiceModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as InvoiceModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    balances(lectureToken: string, signal?: AbortSignal): Promise<MemberBalanceModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/lecture/{lectureToken}/balances";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBalances(_response);
        });
    }

    protected processBalances(response: Response): Promise<MemberBalanceModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberBalanceModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberBalanceModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    transactions(lectureToken: string, studentToken: string, signal?: AbortSignal): Promise<LedgerTransactionModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/lecture/{lectureToken}/member/{studentToken}/transactions";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransactions(_response);
        });
    }

    protected processTransactions(response: Response): Promise<LedgerTransactionModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LedgerTransactionModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LedgerTransactionModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    cancel(invoiceToken: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Invoice/{invoiceToken}/cancel";
        if (invoiceToken === undefined || invoiceToken === null)
            throw new Error("The parameter 'invoiceToken' must be defined.");
        url_ = url_.replace("{invoiceToken}", encodeURIComponent("" + invoiceToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLectureByToken(token: string, signal?: AbortSignal): Promise<LectureSummaryModel> {
        let url_ = this.baseUrl + "/api/Lecture/GetLectureByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureByToken(_response);
        });
    }

    protected processGetLectureByToken(response: Response): Promise<LectureSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel>(null as any);
    }

    /**
     * @return OK
     */
    getLectureGraphByToken(token: string, signal?: AbortSignal): Promise<LectureGraphModel> {
        let url_ = this.baseUrl + "/api/Lecture/GetLectureGraphByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureGraphByToken(_response);
        });
    }

    protected processGetLectureGraphByToken(response: Response): Promise<LectureGraphModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureGraphModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureGraphModel>(null as any);
    }

    /**
     * @return OK
     */
    getLectureMemberEnrollmentsByLecture(lectureToken: string, signal?: AbortSignal): Promise<MemberEnrollmentModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/GetLectureMemberEnrollmentsByLecture/{lectureToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureMemberEnrollmentsByLecture(_response);
        });
    }

    protected processGetLectureMemberEnrollmentsByLecture(response: Response): Promise<MemberEnrollmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getLectureMemberEnrollments(signal?: AbortSignal): Promise<MemberEnrollmentModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/GetLectureMemberEnrollments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureMemberEnrollments(_response);
        });
    }

    protected processGetLectureMemberEnrollments(response: Response): Promise<MemberEnrollmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModel[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param type (optional) 
     * @param includeDecided (optional) 
     * @return OK
     */
    joinRequests(page?: number | undefined, pageSize?: number | undefined, type?: JoinRequestType | undefined, includeDecided?: boolean | undefined, signal?: AbortSignal): Promise<MemberEnrollmentModelPagedResult> {
        let url_ = this.baseUrl + "/api/Lecture/join-requests?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (includeDecided === null)
            throw new Error("The parameter 'includeDecided' cannot be null.");
        else if (includeDecided !== undefined)
            url_ += "includeDecided=" + encodeURIComponent("" + includeDecided) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJoinRequests(_response);
        });
    }

    protected processJoinRequests(response: Response): Promise<MemberEnrollmentModelPagedResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelPagedResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelPagedResult>(null as any);
    }

    /**
     * @return OK
     */
    myLectures(signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/my-lectures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyLectures(_response);
        });
    }

    protected processMyLectures(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @return OK
     */
    getMyCalendarLectures(start?: Date | undefined, end?: Date | undefined, signal?: AbortSignal): Promise<MemberEnrollmentModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/getMyCalendarLectures?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCalendarLectures(_response);
        });
    }

    protected processGetMyCalendarLectures(response: Response): Promise<MemberEnrollmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModel[]>(null as any);
    }

    /**
     * @return OK
     */
    subscriptedLectures(signal?: AbortSignal): Promise<MemberEnrollmentModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/subscriptedLectures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriptedLectures(_response);
        });
    }

    protected processSubscriptedLectures(response: Response): Promise<MemberEnrollmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModel[]>(null as any);
    }

    /**
     * @return OK
     */
    favoriteLectures(signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/favoriteLectures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFavoriteLectures(_response);
        });
    }

    protected processFavoriteLectures(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitReview(body?: ReviewModel | undefined, signal?: AbortSignal): Promise<ReviewModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/SubmitReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitReview(_response);
        });
    }

    protected processSubmitReview(response: Response): Promise<ReviewModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ReviewModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReviewModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitTutorFeedback(body?: TutorFeedbackModel | undefined, signal?: AbortSignal): Promise<TutorFeedbackModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/SubmitTutorFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitTutorFeedback(_response);
        });
    }

    protected processSubmitTutorFeedback(response: Response): Promise<TutorFeedbackModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorFeedbackModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorFeedbackModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getStudentFeedback(studentToken: string, signal?: AbortSignal): Promise<TutorFeedbackModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/GetStudentFeedback/{studentToken}";
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudentFeedback(_response);
        });
    }

    protected processGetStudentFeedback(response: Response): Promise<TutorFeedbackModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorFeedbackModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorFeedbackModelIListRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getMyFeedbackForLectureStudent(lectureToken: string, studentToken: string, signal?: AbortSignal): Promise<TutorFeedbackModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/GetMyFeedbackForLectureStudent/{lectureToken}/{studentToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyFeedbackForLectureStudent(_response);
        });
    }

    protected processGetMyFeedbackForLectureStudent(response: Response): Promise<TutorFeedbackModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorFeedbackModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorFeedbackModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMyProgress(body?: UpdateProgressRequest | undefined, signal?: AbortSignal): Promise<LectureProgressModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/UpdateMyProgress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMyProgress(_response);
        });
    }

    protected processUpdateMyProgress(response: Response): Promise<LectureProgressModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureProgressModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureProgressModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getStudentProgress(lectureToken: string, studentToken: string, signal?: AbortSignal): Promise<LectureProgressModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/GetStudentProgress/{lectureToken}/{studentToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudentProgress(_response);
        });
    }

    protected processGetStudentProgress(response: Response): Promise<LectureProgressModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureProgressModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureProgressModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    adminDecision(body?: ApproveJoinRequestModel | undefined, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/join-requests/admin-decision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminDecision(_response);
        });
    }

    protected processAdminDecision(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    inviteStudentToLecture(lectureToken: string, studentToken: string, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/InviteStudentToLecture/{lectureToken}/{studentToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (studentToken === undefined || studentToken === null)
            throw new Error("The parameter 'studentToken' must be defined.");
        url_ = url_.replace("{studentToken}", encodeURIComponent("" + studentToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteStudentToLecture(_response);
        });
    }

    protected processInviteStudentToLecture(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    respondInvitation(body?: ApproveJoinRequestModel | undefined, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/join-requests/respond-invitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRespondInvitation(_response);
        });
    }

    protected processRespondInvitation(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    toggleFavorite(body?: string | undefined, signal?: AbortSignal): Promise<boolean | null> {
        let url_ = this.baseUrl + "/api/Lecture/ToggleFavorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToggleFavorite(_response);
        });
    }

    protected processToggleFavorite(response: Response): Promise<boolean | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean | null>(null as any);
    }

    /**
     * @return OK
     */
    adminApproveEnrollmentRequest(lectureToken: string, userToken: string, confirmed: boolean, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/memberEnrollments/{lectureToken}/AdminApproveEnrollmentRequest/{userToken}/{confirmed}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (userToken === undefined || userToken === null)
            throw new Error("The parameter 'userToken' must be defined.");
        url_ = url_.replace("{userToken}", encodeURIComponent("" + userToken));
        if (confirmed === undefined || confirmed === null)
            throw new Error("The parameter 'confirmed' must be defined.");
        url_ = url_.replace("{confirmed}", encodeURIComponent("" + confirmed));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminApproveEnrollmentRequest(_response);
        });
    }

    protected processAdminApproveEnrollmentRequest(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    studentApproveEnrollmentInvitation(lectureToken: string, userToken: string, confirmed: boolean, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/memberEnrollments/{lectureToken}/StudentApproveEnrollmentInvitation/{userToken}/{confirmed}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (userToken === undefined || userToken === null)
            throw new Error("The parameter 'userToken' must be defined.");
        url_ = url_.replace("{userToken}", encodeURIComponent("" + userToken));
        if (confirmed === undefined || confirmed === null)
            throw new Error("The parameter 'confirmed' must be defined.");
        url_ = url_.replace("{confirmed}", encodeURIComponent("" + confirmed));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStudentApproveEnrollmentInvitation(_response);
        });
    }

    protected processStudentApproveEnrollmentInvitation(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    tutorLectures(signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/tutorLectures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTutorLectures(_response);
        });
    }

    protected processTutorLectures(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    byTutor(tutorToken: string, signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/byTutor/{tutorToken}";
        if (tutorToken === undefined || tutorToken === null)
            throw new Error("The parameter 'tutorToken' must be defined.");
        url_ = url_.replace("{tutorToken}", encodeURIComponent("" + tutorToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processByTutor(_response);
        });
    }

    protected processByTutor(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    inviteTutorToLecture(lectureToken: string, tutorToken: string, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/InviteTutorToLecture/{lectureToken}/{tutorToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (tutorToken === undefined || tutorToken === null)
            throw new Error("The parameter 'tutorToken' must be defined.");
        url_ = url_.replace("{tutorToken}", encodeURIComponent("" + tutorToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInviteTutorToLecture(_response);
        });
    }

    protected processInviteTutorToLecture(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteEnrollment(lectureToken: string, memberToken: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/DeleteEnrollment/{lectureToken}/{memberToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        if (memberToken === undefined || memberToken === null)
            throw new Error("The parameter 'memberToken' must be defined.");
        url_ = url_.replace("{memberToken}", encodeURIComponent("" + memberToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteEnrollment(_response);
        });
    }

    protected processDeleteEnrollment(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setLectureRating(body?: LectureRatingRequst | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Lecture/SetLectureRating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetLectureRating(_response);
        });
    }

    protected processSetLectureRating(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    ownLectures(courseToken: string, signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/OwnLectures/{courseToken}";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOwnLectures(_response);
        });
    }

    protected processOwnLectures(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    forInvoiceManagement(courseToken: string, signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/ForInvoiceManagement/{courseToken}";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForInvoiceManagement(_response);
        });
    }

    protected processForInvoiceManagement(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getLectureParticipatedLectures(signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/GetLectureParticipatedLectures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureParticipatedLectures(_response);
        });
    }

    protected processGetLectureParticipatedLectures(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getLectureSubscriptedLectures(signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/GetLectureSubscriptedLectures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureSubscriptedLectures(_response);
        });
    }

    protected processGetLectureSubscriptedLectures(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getLectureMyLectures(signal?: AbortSignal): Promise<LectureSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Lecture/GetLectureMyLectures";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureMyLectures(_response);
        });
    }

    protected processGetLectureMyLectures(response: Response): Promise<LectureSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    intLecture(courseToken: string, token: string, signal?: AbortSignal): Promise<LectureSaveRequest> {
        let url_ = this.baseUrl + "/api/Lecture/InitLectureFormByToken/course/{courseToken}/intLecture/{token}";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIntLecture(_response);
        });
    }

    protected processIntLecture(response: Response): Promise<LectureSaveRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureSaveRequest;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureSaveRequest>(null as any);
    }

    /**
     * @param lectureJson (optional) 
     * @param videoFile (optional) 
     * @param pdfFile (optional) 
     * @param thumbnailFile (optional) 
     * @return OK
     */
    saveLectureRequest(lectureJson?: string | undefined, videoFile?: FileParameter | undefined, pdfFile?: FileParameter | undefined, thumbnailFile?: FileParameter | undefined, signal?: AbortSignal): Promise<LectureGraphModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/SaveLectureRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (lectureJson === null || lectureJson === undefined)
            throw new Error("The parameter 'lectureJson' cannot be null.");
        else
            content_.append("LectureJson", lectureJson.toString());
        if (videoFile !== null && videoFile !== undefined)
            content_.append("VideoFile", videoFile.data, videoFile.fileName ? videoFile.fileName : "VideoFile");
        if (pdfFile !== null && pdfFile !== undefined)
            content_.append("PdfFile", pdfFile.data, pdfFile.fileName ? pdfFile.fileName : "PdfFile");
        if (thumbnailFile !== null && thumbnailFile !== undefined)
            content_.append("ThumbnailFile", thumbnailFile.data, thumbnailFile.fileName ? thumbnailFile.fileName : "ThumbnailFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveLectureRequest(_response);
        });
    }

    protected processSaveLectureRequest(response: Response): Promise<LectureGraphModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureGraphModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureGraphModelRestApiResponse>(null as any);
    }

    /**
     * @param lectureJson (optional) 
     * @param videoFile (optional) 
     * @param pdfFile (optional) 
     * @param thumbnailFile (optional) 
     * @return OK
     */
    lecture(lectureJson?: string | undefined, videoFile?: FileParameter | undefined, pdfFile?: FileParameter | undefined, thumbnailFile?: FileParameter | undefined, signal?: AbortSignal): Promise<LectureGraphModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (lectureJson === null || lectureJson === undefined)
            throw new Error("The parameter 'lectureJson' cannot be null.");
        else
            content_.append("LectureJson", lectureJson.toString());
        if (videoFile !== null && videoFile !== undefined)
            content_.append("VideoFile", videoFile.data, videoFile.fileName ? videoFile.fileName : "VideoFile");
        if (pdfFile !== null && pdfFile !== undefined)
            content_.append("PdfFile", pdfFile.data, pdfFile.fileName ? pdfFile.fileName : "PdfFile");
        if (thumbnailFile !== null && thumbnailFile !== undefined)
            content_.append("ThumbnailFile", thumbnailFile.data, thumbnailFile.fileName ? thumbnailFile.fileName : "ThumbnailFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLecture(_response);
        });
    }

    protected processLecture(response: Response): Promise<LectureGraphModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as LectureGraphModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LectureGraphModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    requestJoinAsTutor(lectureToken: string, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/requestJoinAsTutor/{lectureToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestJoinAsTutor(_response);
        });
    }

    protected processRequestJoinAsTutor(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteLecture(token: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/DeleteLecture/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLecture(_response);
        });
    }

    protected processDeleteLecture(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    enrollAsStudent(lectureToken: string, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Lecture/enrollAsStudent/{lectureToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnrollAsStudent(_response);
        });
    }

    protected processEnrollAsStudent(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    unreadCount(signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/api/Messaging/unread-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnreadCount(_response);
        });
    }

    protected processUnreadCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    conversations(signal?: AbortSignal): Promise<ConversationDto[]> {
        let url_ = this.baseUrl + "/api/Messaging/conversations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConversations(_response);
        });
    }

    protected processConversations(response: Response): Promise<ConversationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ConversationDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationDto[]>(null as any);
    }

    /**
     * @return OK
     */
    start(otherUserToken: string, signal?: AbortSignal): Promise<ConversationDto> {
        let url_ = this.baseUrl + "/api/Messaging/conversations/start/{otherUserToken}";
        if (otherUserToken === undefined || otherUserToken === null)
            throw new Error("The parameter 'otherUserToken' must be defined.");
        url_ = url_.replace("{otherUserToken}", encodeURIComponent("" + otherUserToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: Response): Promise<ConversationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ConversationDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationDto>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    messagesAll(conversationToken: string, page?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<MessageDto[]> {
        let url_ = this.baseUrl + "/api/Messaging/conversations/{conversationToken}/messages?";
        if (conversationToken === undefined || conversationToken === null)
            throw new Error("The parameter 'conversationToken' must be defined.");
        url_ = url_.replace("{conversationToken}", encodeURIComponent("" + conversationToken));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMessagesAll(_response);
        });
    }

    protected processMessagesAll(response: Response): Promise<MessageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MessageDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    messages(conversationToken: string, body?: SendMessageRequest | undefined, signal?: AbortSignal): Promise<MessageDto> {
        let url_ = this.baseUrl + "/api/Messaging/conversations/{conversationToken}/messages";
        if (conversationToken === undefined || conversationToken === null)
            throw new Error("The parameter 'conversationToken' must be defined.");
        url_ = url_.replace("{conversationToken}", encodeURIComponent("" + conversationToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMessages(_response);
        });
    }

    protected processMessages(response: Response): Promise<MessageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MessageDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageDto>(null as any);
    }

    /**
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getNotificationsList(pageNumber?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal): Promise<NotificationItemModel[]> {
        let url_ = this.baseUrl + "/api/Notification/GetNotificationsList?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationsList(_response);
        });
    }

    protected processGetNotificationsList(response: Response): Promise<NotificationItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as NotificationItemModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationItemModel[]>(null as any);
    }

    /**
     * @return OK
     */
    stream(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Notification/stream";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStream(_response);
        });
    }

    protected processStream(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    setSeen(token?: string | undefined, signal?: AbortSignal): Promise<NotificationItemModel> {
        let url_ = this.baseUrl + "/api/Notification/setSeen?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetSeen(_response);
        });
    }

    protected processSetSeen(response: Response): Promise<NotificationItemModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as NotificationItemModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationItemModel>(null as any);
    }

    /**
     * @return OK
     */
    markAllSeen(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Notification/markAllSeen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkAllSeen(_response);
        });
    }

    protected processMarkAllSeen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    childrenAll(signal?: AbortSignal): Promise<ParentChildModel[]> {
        let url_ = this.baseUrl + "/api/Parent/children";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChildrenAll(_response);
        });
    }

    protected processChildrenAll(response: Response): Promise<ParentChildModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ParentChildModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentChildModel[]>(null as any);
    }

    /**
     * @return OK
     */
    enrollments(childToken: string, signal?: AbortSignal): Promise<MemberEnrollmentModel[]> {
        let url_ = this.baseUrl + "/api/Parent/children/{childToken}/enrollments";
        if (childToken === undefined || childToken === null)
            throw new Error("The parameter 'childToken' must be defined.");
        url_ = url_.replace("{childToken}", encodeURIComponent("" + childToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnrollments(_response);
        });
    }

    protected processEnrollments(response: Response): Promise<MemberEnrollmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body?: CreateChildRequest | undefined, signal?: AbortSignal): Promise<ParentChildModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Parent/children/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ParentChildModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ParentChildModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentChildModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    link(body?: LinkChildRequest | undefined, signal?: AbortSignal): Promise<ParentChildModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Parent/children/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLink(_response);
        });
    }

    protected processLink(response: Response): Promise<ParentChildModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ParentChildModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentChildModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    enroll(childToken: string, lectureToken: string, signal?: AbortSignal): Promise<MemberEnrollmentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Parent/children/{childToken}/enroll/{lectureToken}";
        if (childToken === undefined || childToken === null)
            throw new Error("The parameter 'childToken' must be defined.");
        url_ = url_.replace("{childToken}", encodeURIComponent("" + childToken));
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnroll(_response);
        });
    }

    protected processEnroll(response: Response): Promise<MemberEnrollmentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as MemberEnrollmentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MemberEnrollmentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    children(childToken: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Parent/children/{childToken}";
        if (childToken === undefined || childToken === null)
            throw new Error("The parameter 'childToken' must be defined.");
        url_ = url_.replace("{childToken}", encodeURIComponent("" + childToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChildren(_response);
        });
    }

    protected processChildren(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setPassword(childToken: string, body?: SetChildPasswordRequest | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Parent/children/{childToken}/set-password";
        if (childToken === undefined || childToken === null)
            throw new Error("The parameter 'childToken' must be defined.");
        url_ = url_.replace("{childToken}", encodeURIComponent("" + childToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPassword(_response);
        });
    }

    protected processSetPassword(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    myPayments(signal?: AbortSignal): Promise<PaymentModel[]> {
        let url_ = this.baseUrl + "/api/Payment/my-payments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyPayments(_response);
        });
    }

    protected processMyPayments(response: Response): Promise<PaymentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PaymentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentModel[]>(null as any);
    }

    /**
     * @return OK
     */
    balanceSummary(signal?: AbortSignal): Promise<PaymentBalanceSummary> {
        let url_ = this.baseUrl + "/api/Payment/balance-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBalanceSummary(_response);
        });
    }

    protected processBalanceSummary(response: Response): Promise<PaymentBalanceSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PaymentBalanceSummary;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentBalanceSummary>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    recordPayments(body?: BulkPaymentSaveRequest | undefined, signal?: AbortSignal): Promise<PaymentModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payment/recordPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecordPayments(_response);
        });
    }

    protected processRecordPayments(response: Response): Promise<PaymentModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PaymentModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentModelIListRestApiResponse>(null as any);
    }

    /**
     * @param userTypeEnum (optional) 
     * @return OK
     */
    deletePayment(token: string, userTypeEnum?: UserTypeEnum | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payment/deletePayment/{token}?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        if (userTypeEnum === null)
            throw new Error("The parameter 'userTypeEnum' cannot be null.");
        else if (userTypeEnum !== undefined)
            url_ += "userTypeEnum=" + encodeURIComponent("" + userTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePayment(_response);
        });
    }

    protected processDeletePayment(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    verifyPaypalAccount(email?: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Payout/verify-paypal-account?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyPaypalAccount(_response);
        });
    }

    protected processVerifyPaypalAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    pendingOrders(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Payout/pending-orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPendingOrders(_response);
        });
    }

    protected processPendingOrders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createLecturePayment(body?: PayoutRequist | undefined, signal?: AbortSignal): Promise<StringRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/create-lecture-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLecturePayment(_response);
        });
    }

    protected processCreateLecturePayment(response: Response): Promise<StringRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StringRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    createInvoicePayment(invoiceToken: string, signal?: AbortSignal): Promise<StringRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/create-invoice-payment/{invoiceToken}";
        if (invoiceToken === undefined || invoiceToken === null)
            throw new Error("The parameter 'invoiceToken' must be defined.");
        url_ = url_.replace("{invoiceToken}", encodeURIComponent("" + invoiceToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInvoicePayment(_response);
        });
    }

    protected processCreateInvoicePayment(response: Response): Promise<StringRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StringRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    createPayment(invoiceToken: string, signal?: AbortSignal): Promise<PaypalOrderCreationResultRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/public/invoice/{invoiceToken}/create-payment";
        if (invoiceToken === undefined || invoiceToken === null)
            throw new Error("The parameter 'invoiceToken' must be defined.");
        url_ = url_.replace("{invoiceToken}", encodeURIComponent("" + invoiceToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePayment(_response);
        });
    }

    protected processCreatePayment(response: Response): Promise<PaypalOrderCreationResultRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PaypalOrderCreationResultRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaypalOrderCreationResultRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    processPayment(orderId: string, signal?: AbortSignal): Promise<PaymentResponseMessageRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/public/process-payment/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessPayment(_response);
        });
    }

    protected processProcessPayment(response: Response): Promise<PaymentResponseMessageRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PaymentResponseMessageRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentResponseMessageRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    paypalOrder(orderId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Payout/paypal-order/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPaypalOrder(_response);
        });
    }

    protected processPaypalOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createLectureSubscriptionPayment(body?: PayoutRequist | undefined, signal?: AbortSignal): Promise<StringRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/create-lecture-subscription-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLectureSubscriptionPayment(_response);
        });
    }

    protected processCreateLectureSubscriptionPayment(response: Response): Promise<StringRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StringRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    tutorSubscriptionTransactionsList(signal?: AbortSignal): Promise<UserSubscriptionModel[]> {
        let url_ = this.baseUrl + "/api/Payout/tutorSubscriptionTransactionsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTutorSubscriptionTransactionsList(_response);
        });
    }

    protected processTutorSubscriptionTransactionsList(response: Response): Promise<UserSubscriptionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as UserSubscriptionModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSubscriptionModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getTransactions(selectedStartDate: Date, selectedEndDate: Date, signal?: AbortSignal): Promise<TransactionModel[]> {
        let url_ = this.baseUrl + "/api/Payout/getTransactions/{selectedStartDate}/{selectedEndDate}";
        if (selectedStartDate === undefined || selectedStartDate === null)
            throw new Error("The parameter 'selectedStartDate' must be defined.");
        url_ = url_.replace("{selectedStartDate}", encodeURIComponent(selectedStartDate ? "" + selectedStartDate.toISOString() : "null"));
        if (selectedEndDate === undefined || selectedEndDate === null)
            throw new Error("The parameter 'selectedEndDate' must be defined.");
        url_ = url_.replace("{selectedEndDate}", encodeURIComponent(selectedEndDate ? "" + selectedEndDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTransactions(_response);
        });
    }

    protected processGetTransactions(response: Response): Promise<TransactionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TransactionModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransactionModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTutorSubscriptionPayment(body?: SubscriptionCartItem[] | undefined, signal?: AbortSignal): Promise<StringRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/create-tutor-subscription-payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTutorSubscriptionPayment(_response);
        });
    }

    protected processCreateTutorSubscriptionPayment(response: Response): Promise<StringRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StringRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    cancelPayment(orderId: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/cancel-payment/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelPayment(_response);
        });
    }

    protected processCancelPayment(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    processPayment2(orderId: string, signal?: AbortSignal): Promise<PaymentResponseMessageRestApiResponse> {
        let url_ = this.baseUrl + "/api/Payout/process-payment/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessPayment2(_response);
        });
    }

    protected processProcessPayment2(response: Response): Promise<PaymentResponseMessageRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PaymentResponseMessageRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentResponseMessageRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    orders(body?: any | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/PayPal/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrders(_response);
        });
    }

    protected processOrders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    capture(orderID: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/PayPal/orders/{orderID}/capture";
        if (orderID === undefined || orderID === null)
            throw new Error("The parameter 'orderID' must be defined.");
        url_ = url_.replace("{orderID}", encodeURIComponent("" + orderID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCapture(_response);
        });
    }

    protected processCapture(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    promoCodeGET(signal?: AbortSignal): Promise<PromoCodeIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/PromoCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPromoCodeGET(_response);
        });
    }

    protected processPromoCodeGET(response: Response): Promise<PromoCodeIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PromoCodeIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoCodeIListRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    promoCodePOST(body?: PromoCode | undefined, signal?: AbortSignal): Promise<PromoCodeRestApiResponse> {
        let url_ = this.baseUrl + "/api/PromoCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPromoCodePOST(_response);
        });
    }

    protected processPromoCodePOST(response: Response): Promise<PromoCodeRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PromoCodeRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoCodeRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    validate(code: string, signal?: AbortSignal): Promise<PromoCodeRestApiResponse> {
        let url_ = this.baseUrl + "/api/PromoCode/validate/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: Response): Promise<PromoCodeRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PromoCodeRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoCodeRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    promoCodePUT(token: string, body?: PromoCode | undefined, signal?: AbortSignal): Promise<PromoCodeRestApiResponse> {
        let url_ = this.baseUrl + "/api/PromoCode/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPromoCodePUT(_response);
        });
    }

    protected processPromoCodePUT(response: Response): Promise<PromoCodeRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as PromoCodeRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoCodeRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    promoCodeDELETE(token: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/PromoCode/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPromoCodeDELETE(_response);
        });
    }

    protected processPromoCodeDELETE(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    items(courseToken: string, signal?: AbortSignal): Promise<QuestionBankItemModelIListRestApiResponse> {
        let url_ = this.baseUrl + "/api/QuestionBank/course/{courseToken}/items";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processItems(_response);
        });
    }

    protected processItems(response: Response): Promise<QuestionBankItemModelIListRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as QuestionBankItemModelIListRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionBankItemModelIListRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveQuestionBankItem(body?: QuestionBankSaveRequest | undefined, signal?: AbortSignal): Promise<QuestionBankItemModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/QuestionBank/saveQuestionBankItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveQuestionBankItem(_response);
        });
    }

    protected processSaveQuestionBankItem(response: Response): Promise<QuestionBankItemModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as QuestionBankItemModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionBankItemModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    deleteQuestionBankItem(itemToken: string, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/QuestionBank/DeleteQuestionBankItem/{itemToken}";
        if (itemToken === undefined || itemToken === null)
            throw new Error("The parameter 'itemToken' must be defined.");
        url_ = url_.replace("{itemToken}", encodeURIComponent("" + itemToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionBankItem(_response);
        });
    }

    protected processDeleteQuestionBankItem(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param lectureToken (optional) 
     * @param keyword (optional) 
     * @param maxcount (optional) 
     * @return OK
     */
    searchStudentForLectureInvitation(lectureToken?: string | undefined, keyword?: string | undefined, maxcount?: number | undefined, signal?: AbortSignal): Promise<StudentModel[]> {
        let url_ = this.baseUrl + "/api/Student/searchStudentForLectureInvitation?";
        if (lectureToken === null)
            throw new Error("The parameter 'lectureToken' cannot be null.");
        else if (lectureToken !== undefined)
            url_ += "lectureToken=" + encodeURIComponent("" + lectureToken) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxcount === null)
            throw new Error("The parameter 'maxcount' cannot be null.");
        else if (maxcount !== undefined)
            url_ += "maxcount=" + encodeURIComponent("" + maxcount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchStudentForLectureInvitation(_response);
        });
    }

    protected processSearchStudentForLectureInvitation(response: Response): Promise<StudentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StudentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveStudent(body?: SaveStudentRequest | undefined, signal?: AbortSignal): Promise<StudentModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Student/SaveStudent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveStudent(_response);
        });
    }

    protected processSaveStudent(response: Response): Promise<StudentModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StudentModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getStudentByToken(token: string, signal?: AbortSignal): Promise<StudentSummaryModel> {
        let url_ = this.baseUrl + "/api/Student/GetStudentByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudentByToken(_response);
        });
    }

    protected processGetStudentByToken(response: Response): Promise<StudentSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StudentSummaryModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentSummaryModel>(null as any);
    }

    /**
     * @return OK
     */
    myStudents(signal?: AbortSignal): Promise<StudentSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Student/myStudents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMyStudents(_response);
        });
    }

    protected processMyStudents(response: Response): Promise<StudentSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StudentSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudentSummaryModel[]>(null as any);
    }

    /**
     * @param pendingOnly (optional) 
     * @return OK
     */
    parentLinkRequests(pendingOnly?: boolean | undefined, signal?: AbortSignal): Promise<ParentChildModel[]> {
        let url_ = this.baseUrl + "/api/Student/parentLinkRequests?";
        if (pendingOnly === null)
            throw new Error("The parameter 'pendingOnly' cannot be null.");
        else if (pendingOnly !== undefined)
            url_ += "pendingOnly=" + encodeURIComponent("" + pendingOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processParentLinkRequests(_response);
        });
    }

    protected processParentLinkRequests(response: Response): Promise<ParentChildModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ParentChildModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentChildModel[]>(null as any);
    }

    /**
     * @param isAccepted (optional) 
     * @return OK
     */
    respond(parentToken: string, isAccepted?: boolean | undefined, signal?: AbortSignal): Promise<ParentChildModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Student/parentLinkRequests/{parentToken}/respond?";
        if (parentToken === undefined || parentToken === null)
            throw new Error("The parameter 'parentToken' must be defined.");
        url_ = url_.replace("{parentToken}", encodeURIComponent("" + parentToken));
        if (isAccepted === null)
            throw new Error("The parameter 'isAccepted' cannot be null.");
        else if (isAccepted !== undefined)
            url_ += "isAccepted=" + encodeURIComponent("" + isAccepted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRespond(_response);
        });
    }

    protected processRespond(response: Response): Promise<ParentChildModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as ParentChildModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParentChildModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionPlansFullList(signal?: AbortSignal): Promise<SubscriptionPlanFullPricingModel[]> {
        let url_ = this.baseUrl + "/api/Subscription/SubscriptionPlansFullList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscriptionPlansFullList(_response);
        });
    }

    protected processSubscriptionPlansFullList(response: Response): Promise<SubscriptionPlanFullPricingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as SubscriptionPlanFullPricingModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionPlanFullPricingModel[]>(null as any);
    }

    /**
     * @param currencyCode (optional) 
     * @return OK
     */
    publicPricing(currencyCode?: string | undefined, signal?: AbortSignal): Promise<SubscriptionPlanFullPricingModel[]> {
        let url_ = this.baseUrl + "/api/Subscription/PublicPricing?";
        if (currencyCode === null)
            throw new Error("The parameter 'currencyCode' cannot be null.");
        else if (currencyCode !== undefined)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublicPricing(_response);
        });
    }

    protected processPublicPricing(response: Response): Promise<SubscriptionPlanFullPricingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as SubscriptionPlanFullPricingModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionPlanFullPricingModel[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @return OK
     */
    currencyForCountry(countryCode?: string | undefined, signal?: AbortSignal): Promise<CurrencyRecommendationModel> {
        let url_ = this.baseUrl + "/api/Subscription/CurrencyForCountry?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrencyForCountry(_response);
        });
    }

    protected processCurrencyForCountry(response: Response): Promise<CurrencyRecommendationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as CurrencyRecommendationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyRecommendationModel>(null as any);
    }

    /**
     * @param lectureToken (optional) 
     * @param keyword (optional) 
     * @param maxcount (optional) 
     * @return OK
     */
    searchTutorForLectureInvitation(lectureToken?: string | undefined, keyword?: string | undefined, maxcount?: number | undefined, signal?: AbortSignal): Promise<TutorModel[]> {
        let url_ = this.baseUrl + "/api/Tutor/searchTutorForLectureInvitation?";
        if (lectureToken === null)
            throw new Error("The parameter 'lectureToken' cannot be null.");
        else if (lectureToken !== undefined)
            url_ += "lectureToken=" + encodeURIComponent("" + lectureToken) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxcount === null)
            throw new Error("The parameter 'maxcount' cannot be null.");
        else if (maxcount !== undefined)
            url_ += "maxcount=" + encodeURIComponent("" + maxcount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchTutorForLectureInvitation(_response);
        });
    }

    protected processSearchTutorForLectureInvitation(response: Response): Promise<TutorModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorModel[]>(null as any);
    }

    /**
     * @param accountInfoModelJson (optional) 
     * @param imageFile (optional) 
     * @return OK
     */
    saveTutor(accountInfoModelJson?: string | undefined, imageFile?: FileParameter | undefined, signal?: AbortSignal): Promise<TutorModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Tutor/SaveTutor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountInfoModelJson === null || accountInfoModelJson === undefined)
            throw new Error("The parameter 'accountInfoModelJson' cannot be null.");
        else
            content_.append("accountInfoModelJson", accountInfoModelJson.toString());
        if (imageFile !== null && imageFile !== undefined)
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveTutor(_response);
        });
    }

    protected processSaveTutor(response: Response): Promise<TutorModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getTutorByToken(token: string, signal?: AbortSignal): Promise<TutorSummaryModel> {
        let url_ = this.baseUrl + "/api/Tutor/GetTutorByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTutorByToken(_response);
        });
    }

    protected processGetTutorByToken(response: Response): Promise<TutorSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorSummaryModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorSummaryModel>(null as any);
    }

    /**
     * @return OK
     */
    getLectureTutorsByLectureToken(lectureToken: string, signal?: AbortSignal): Promise<TutorSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Tutor/GetLectureTutorsByLectureToken/{lectureToken}";
        if (lectureToken === undefined || lectureToken === null)
            throw new Error("The parameter 'lectureToken' must be defined.");
        url_ = url_.replace("{lectureToken}", encodeURIComponent("" + lectureToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLectureTutorsByLectureToken(_response);
        });
    }

    protected processGetLectureTutorsByLectureToken(response: Response): Promise<TutorSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getCourseTutorsByCourseToken(courseToken: string, signal?: AbortSignal): Promise<TutorSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Tutor/GetCourseTutorsByCourseToken/{courseToken}";
        if (courseToken === undefined || courseToken === null)
            throw new Error("The parameter 'courseToken' must be defined.");
        url_ = url_.replace("{courseToken}", encodeURIComponent("" + courseToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCourseTutorsByCourseToken(_response);
        });
    }

    protected processGetCourseTutorsByCourseToken(response: Response): Promise<TutorSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    getTutorGraphByToken(token: string, signal?: AbortSignal): Promise<TutorModel> {
        let url_ = this.baseUrl + "/api/Tutor/GetTutorGraphByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTutorGraphByToken(_response);
        });
    }

    protected processGetTutorGraphByToken(response: Response): Promise<TutorModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorModel>(null as any);
    }

    /**
     * @return OK
     */
    getAcademyAffiliation(token: string, signal?: AbortSignal): Promise<AcademyAffiliationModel> {
        let url_ = this.baseUrl + "/api/Tutor/GetAcademyAffiliation/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAcademyAffiliation(_response);
        });
    }

    protected processGetAcademyAffiliation(response: Response): Promise<AcademyAffiliationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AcademyAffiliationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcademyAffiliationModel>(null as any);
    }

    /**
     * @return OK
     */
    getFollowing(signal?: AbortSignal): Promise<TutorSummaryModel[]> {
        let url_ = this.baseUrl + "/api/Tutor/GetFollowing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFollowing(_response);
        });
    }

    protected processGetFollowing(response: Response): Promise<TutorSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorSummaryModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorSummaryModel[]>(null as any);
    }

    /**
     * @return OK
     */
    instructorVerificationList(signal?: AbortSignal): Promise<TutorModel[]> {
        let url_ = this.baseUrl + "/api/Tutor/InstructorVerificationList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInstructorVerificationList(_response);
        });
    }

    protected processInstructorVerificationList(response: Response): Promise<TutorModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tutorToggleFollow(body?: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tutor/TutorToggleFollow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTutorToggleFollow(_response);
        });
    }

    protected processTutorToggleFollow(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param idFrontFile (optional) 
     * @param idBackFile (optional) 
     * @param selfieFile (optional) 
     * @param verificationIdType (optional) 
     * @return OK
     */
    uploadTutorIDFile(idFrontFile?: FileParameter | undefined, idBackFile?: FileParameter | undefined, selfieFile?: FileParameter | undefined, verificationIdType?: VerificationIdTypeEnum | undefined, signal?: AbortSignal): Promise<TutorModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/Tutor/uploadTutorIDFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (idFrontFile !== null && idFrontFile !== undefined)
            content_.append("IdFrontFile", idFrontFile.data, idFrontFile.fileName ? idFrontFile.fileName : "IdFrontFile");
        if (idBackFile !== null && idBackFile !== undefined)
            content_.append("IdBackFile", idBackFile.data, idBackFile.fileName ? idBackFile.fileName : "IdBackFile");
        if (selfieFile !== null && selfieFile !== undefined)
            content_.append("SelfieFile", selfieFile.data, selfieFile.fileName ? selfieFile.fileName : "SelfieFile");
        if (verificationIdType === null || verificationIdType === undefined)
            throw new Error("The parameter 'verificationIdType' cannot be null.");
        else
            content_.append("VerificationIdType", verificationIdType.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadTutorIDFile(_response);
        });
    }

    protected processUploadTutorIDFile(response: Response): Promise<TutorModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as TutorModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TutorModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    login(body?: LoginModel | undefined, signal?: AbortSignal): Promise<AccountInfoModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AccountInfoModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reactivateAccount(body?: LoginModel | undefined, signal?: AbortSignal): Promise<AccountInfoModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/ReactivateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReactivateAccount(_response);
        });
    }

    protected processReactivateAccount(response: Response): Promise<AccountInfoModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModelRestApiResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    verifyEmail(token?: string | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/verify-email?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    googleLogin(body?: GoogleLoginRequest | undefined, signal?: AbortSignal): Promise<AccountInfoModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/googleLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGoogleLogin(_response);
        });
    }

    protected processGoogleLogin(response: Response): Promise<AccountInfoModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModelRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    forgotPassword(body?: ForgotPasswordRequest | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resetPassword(body?: ResetPasswordRequest | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    resendVerification(body?: ResendVerificationRequest | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/resend-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResendVerification(_response);
        });
    }

    protected processResendVerification(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registrationSendOtp(body?: SendRegistrationPhoneOtpRequest | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/phone/registration-send-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistrationSendOtp(_response);
        });
    }

    protected processRegistrationSendOtp(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registrationVerifyOtp(body?: VerifyRegistrationPhoneOtpRequest | undefined, signal?: AbortSignal): Promise<StringRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/phone/registration-verify-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistrationVerifyOtp(_response);
        });
    }

    protected processRegistrationVerifyOtp(response: Response): Promise<StringRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as StringRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    sendOtp(body?: SendPhoneChangeOtpRequest | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/phone/send-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendOtp(_response);
        });
    }

    protected processSendOtp(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    confirm(body?: ConfirmPhoneChangeRequest | undefined, signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/phone/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirm(_response);
        });
    }

    protected processConfirm(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUserInfo(signal?: AbortSignal): Promise<AccountInfoModel> {
        let url_ = this.baseUrl + "/api/User/getCurrentUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUserInfo(_response);
        });
    }

    protected processGetCurrentUserInfo(response: Response): Promise<AccountInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModel>(null as any);
    }

    /**
     * @return OK
     */
    getUserByToken(token: string, signal?: AbortSignal): Promise<UserModel> {
        let url_ = this.baseUrl + "/api/User/GetUserByToken/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserByToken(_response);
        });
    }

    protected processGetUserByToken(response: Response): Promise<UserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as UserModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    registration(body?: RegisterModel | undefined, signal?: AbortSignal): Promise<AccountInfoModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistration(_response);
        });
    }

    protected processRegistration(response: Response): Promise<AccountInfoModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModelRestApiResponse>(null as any);
    }

    /**
     * @param accountInfoModelJson (optional) 
     * @param imageFile (optional) 
     * @return OK
     */
    saveUser(accountInfoModelJson?: string | undefined, imageFile?: FileParameter | undefined, signal?: AbortSignal): Promise<AccountInfoModelRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/SaveUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountInfoModelJson === null || accountInfoModelJson === undefined)
            throw new Error("The parameter 'accountInfoModelJson' cannot be null.");
        else
            content_.append("accountInfoModelJson", accountInfoModelJson.toString());
        if (imageFile !== null && imageFile !== undefined)
            content_.append("ImageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "ImageFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveUser(_response);
        });
    }

    protected processSaveUser(response: Response): Promise<AccountInfoModelRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as AccountInfoModelRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfoModelRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    deactivateMyAccount(signal?: AbortSignal): Promise<BooleanRestApiResponse> {
        let url_ = this.baseUrl + "/api/User/DeactivateMyAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateMyAccount(_response);
        });
    }

    protected processDeactivateMyAccount(response: Response): Promise<BooleanRestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as BooleanRestApiResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanRestApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    userSettingsGET(signal?: AbortSignal): Promise<UserSettingsDto> {
        let url_ = this.baseUrl + "/api/UserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserSettingsGET(_response);
        });
    }

    protected processUserSettingsGET(response: Response): Promise<UserSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as UserSettingsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userSettingsPOST(body?: UserSettingsDto | undefined, signal?: AbortSignal): Promise<UserSettingsDto> {
        let url_ = this.baseUrl + "/api/UserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserSettingsPOST(_response);
        });
    }

    protected processUserSettingsPOST(response: Response): Promise<UserSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver) as UserSettingsDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettingsDto>(null as any);
    }

    /**
     * @return OK
     */
    twiml(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/VoiceHelpline/twiml";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTwiml(_response);
        });
    }

    protected processTwiml(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    relay(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/VoiceHelpline/relay";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRelay(_response);
        });
    }

    protected processRelay(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface Academy {
    token?: string;
    biography?: string | undefined;
    tagline?: string | undefined;
    isVerified?: boolean;
    verificationIdFrontUrl?: string | undefined;
    verificationIdBackUrl?: string | undefined;
    verificationIdType?: number | undefined;
    tags?: string | undefined;
    verificationSelfieUrl?: string | undefined;
    verificationStatus?: number | undefined;
    verificationSubmittedDate?: Date | undefined;
    verificationRejectionReason?: string | undefined;
    courses?: Course[] | undefined;
    tokenNavigation?: User;
    tutors?: Tutor[] | undefined;
}

export interface AcademyAffiliationModel {
    academyToken?: string | undefined;
    academyName?: string | undefined;
    academyTagline?: string | undefined;
}

export interface AcademyProfileModel {
    token: string;
    email: string;
    name: string;
    title?: string | undefined;
    profileUrl?: string | undefined;
    countryCode: string;
    currencyCode: string;
    dob: Date;
    paypalAccount?: string | undefined;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    userType: UserTypeEnum;
    isActive: boolean;
    countryName: string;
    currencyName: string;
    currencySymbol: string;
    isVerified?: boolean;
    biography?: string | undefined;
    tagline?: string | undefined;
    verificationIdFrontUrl?: string | undefined;
    verificationIdBackUrl?: string | undefined;
    verificationSelfieUrl?: string | undefined;
    verificationIdType?: VerificationIdTypeEnum;
    verificationStatus?: VerificationStatusEnum;
    verificationSubmittedDate?: Date | undefined;
    verificationRejectionReason?: string | undefined;
    tags?: string[] | undefined;
    tutorCount?: number;
    courseCount?: number;
    tutors?: TutorSummaryModel[] | undefined;
    courses?: CourseSummaryModel[] | undefined;
}

export interface AcademyProfileModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AcademyProfileModel;
}

export interface AcademyReportsModel {
    totalRevenue?: number;
    currencyCode?: string | undefined;
    totalStudents?: number;
    newStudentsThisMonth?: number;
    totalCourses?: number;
    totalLectures?: number;
    totalTutors?: number;
    averageRating?: number;
    monthlyRevenues?: MonthlyRevenueItem[] | undefined;
    tutorRevenues?: TutorRevenueItem[] | undefined;
    tutorPerformances?: TutorPerformanceItem[] | undefined;
    monthlyNewStudents?: MonthlyStudentsItem[] | undefined;
    topCoursesByEnrollment?: CourseEnrollmentItem[] | undefined;
    liveSessionsCount?: number;
    recordedCount?: number;
    documentCount?: number;
    averageOccupancy?: number;
    upcomingLectures?: UpcomingLectureItem[] | undefined;
    subscriptionStatus?: string | undefined;
    subscriptionEndDate?: Date | undefined;
    planName?: string | undefined;
    daysUntilExpiry?: number;
    tutorRatings?: TutorRatingItem[] | undefined;
}

export interface AcademyReportsModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AcademyReportsModel;
}

export interface AccountInfoModel {
    token: string;
    email: string;
    name: string;
    title?: string | undefined;
    profileUrl?: string | undefined;
    countryCode: string;
    currencyCode: string;
    dob: Date;
    paypalAccount?: string | undefined;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    userType: UserTypeEnum;
    isActive: boolean;
    currencyName: string;
    currencySymbol: string;
    isVerified?: boolean | undefined;
    accessToken?: string | undefined;
    subscriptionCurrencyCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isIdentityVerified?: boolean | undefined;
    isActiveSubscription?: boolean | undefined;
    countryName?: string | undefined;
    academyToken?: string | undefined;
    isInTrial?: boolean | undefined;
    trialEndDate?: Date | undefined;
    userSubscriptionStatus?: UserSubscriptionStatusEnum;
}

export interface AccountInfoModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AccountInfoModel[] | undefined;
}

export interface AccountInfoModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AccountInfoModel;
}

export interface AddAcademyTutorRequest {
    name?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    countryCode?: string | undefined;
    dob?: Date;
    phoneNumber?: string | undefined;
    phoneVerificationProof?: string | undefined;
}

export interface AgoraAccessTokenObj {
    token?: string | undefined;
    appId?: string | undefined;
    channelName?: string | undefined;
    isSuccess?: boolean;
    isHost?: boolean;
    uid?: number;
}

export interface AgoraAccessTokenObjRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AgoraAccessTokenObj;
}

export interface AgoraParticipantDto {
    uid?: number;
    userToken?: string | undefined;
    name?: string | undefined;
    profileUrl?: string | undefined;
    isHost?: boolean;
    userType?: number;
    isMuteLocked?: boolean;
    isCameraLocked?: boolean;
    isKicked?: boolean;
    screenUid?: number | undefined;
}

export interface AgoraParticipantDtoListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AgoraParticipantDto[] | undefined;
}

export interface AgoraParticipantDtoRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AgoraParticipantDto;
}

export interface AiChatMessageModel {
    role?: string | undefined;
    content?: string | undefined;
}

export interface AiChatRequest {
    messages?: AiChatMessageModel[] | undefined;
    language?: string | undefined;
    context?: string | undefined;
}

export interface AiChatResponse {
    reply?: string | undefined;
}

export interface AiChatResponseRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AiChatResponse;
}

export interface ApproveJoinRequestModel {
    lectureToken?: string;
    memberToken?: string | undefined;
    isApproved?: boolean;
}

export interface Assessment {
    token?: string;
    assessmentType?: number;
    courseToken?: string | undefined;
    lectureToken?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    promptPdfUrl?: string | undefined;
    dueDate?: Date | undefined;
    timeLimitMinutes?: number | undefined;
    autoGrade?: boolean;
    createdBy?: string;
    createDate?: Date;
    modifyDate?: Date;
    assessmentAssignedStudents?: AssessmentAssignedStudent[] | undefined;
    assessmentSections?: AssessmentSection[] | undefined;
    assessmentSubmissions?: AssessmentSubmission[] | undefined;
    courseTokenNavigation?: Course;
    createdByNavigation?: User;
    lectureTokenNavigation?: Lecture;
}

export interface AssessmentAnswerModel {
    id: string;
    questionId: string;
    choiceId?: string | undefined;
    matchLeftPairId?: string | undefined;
    matchSelectedRightPairId?: string | undefined;
    answerText?: string | undefined;
    fileUrl?: string | undefined;
    isCorrect?: boolean | undefined;
    pointsAwarded?: number | undefined;
}

export interface AssessmentAssignedStudent {
    assessmentToken?: string;
    studentToken?: string;
    assignedAt?: Date;
    assessmentTokenNavigation?: Assessment;
    studentTokenNavigation?: User;
}

export interface AssessmentChoiceModel {
    id: string;
    choiceText?: string | undefined;
    isCorrect?: boolean | undefined;
    orderIndex?: number;
}

export interface AssessmentChoiceSaveRequest {
    choiceText: string;
    isCorrect?: boolean;
    orderIndex?: number;
}

export interface AssessmentMatchLeftItemModel {
    id: string;
    leftText?: string | undefined;
}

export interface AssessmentMatchPairModel {
    id: string;
    leftText?: string | undefined;
    rightText?: string | undefined;
}

export interface AssessmentMatchPairSaveRequest {
    leftText: string;
    rightText: string;
    orderIndex?: number;
}

export interface AssessmentModel {
    token: string;
    assessmentType?: AssessmentTypeEnum;
    courseToken?: string | undefined;
    lectureToken?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    promptPdfUrl?: string | undefined;
    dueDate?: Date | undefined;
    timeLimitMinutes?: number | undefined;
    maxScore?: number;
    autoGrade?: boolean;
    createdBy?: string;
    createDate?: Date;
    sections?: AssessmentSectionModel[] | undefined;
    assignedStudents?: AssessmentStudentModel[] | undefined;
}

export interface AssessmentModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AssessmentModel[] | undefined;
}

export interface AssessmentModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AssessmentModel;
}

export interface AssessmentQuestion {
    questionType?: number;
    questionText?: string | undefined;
    points?: number;
    orderIndex?: number;
    autoGrade?: boolean | undefined;
    correctAnswerText?: string | undefined;
    token?: string;
    sectionToken?: string;
    assessmentQuestionChoices?: AssessmentQuestionChoice[] | undefined;
    assessmentQuestionMatchPairs?: AssessmentQuestionMatchPair[] | undefined;
    assessmentSubmissionAnswers?: AssessmentSubmissionAnswer[] | undefined;
    sectionTokenNavigation?: AssessmentSection;
}

export interface AssessmentQuestionChoice {
    choiceText?: string | undefined;
    isCorrect?: boolean;
    orderIndex?: number;
    token?: string;
    questionToken?: string;
    assessmentSubmissionAnswers?: AssessmentSubmissionAnswer[] | undefined;
    questionTokenNavigation?: AssessmentQuestion;
}

export interface AssessmentQuestionGradeRequest {
    questionId: string;
    pointsAwarded: number;
    isCorrect?: boolean | undefined;
}

export interface AssessmentQuestionMatchPair {
    leftText?: string | undefined;
    rightText?: string | undefined;
    orderIndex?: number;
    token?: string;
    questionToken?: string;
    assessmentSubmissionAnswerMatchLeftPairTokenNavigations?: AssessmentSubmissionAnswer[] | undefined;
    assessmentSubmissionAnswerMatchSelectedRightPairTokenNavigations?: AssessmentSubmissionAnswer[] | undefined;
    questionTokenNavigation?: AssessmentQuestion;
}

export interface AssessmentQuestionModel {
    id: string;
    questionType?: AssessmentQuestionTypeEnum;
    questionText?: string | undefined;
    points?: number;
    orderIndex?: number;
    autoGrade?: boolean | undefined;
    correctAnswerText?: string | undefined;
    choices?: AssessmentChoiceModel[] | undefined;
    matchLeftItems?: AssessmentMatchLeftItemModel[] | undefined;
    matchRightOptions?: string[] | undefined;
    matchPairs?: AssessmentMatchPairModel[] | undefined;
}

export interface AssessmentQuestionSaveRequest {
    questionType: AssessmentQuestionTypeEnum;
    questionText: string;
    points?: number;
    orderIndex?: number;
    autoGrade?: boolean | undefined;
    correctAnswerText?: string | undefined;
    choices: AssessmentChoiceSaveRequest[];
    matchPairs: AssessmentMatchPairSaveRequest[];
}

export enum AssessmentQuestionTypeEnum {
    MultipleChoice = 1,
    TrueFalse = 2,
    Matching = 3,
    ShortAnswer = 4,
    Essay = 5,
    FileUpload = 6,
}

export interface AssessmentReportItemModel {
    assessmentToken: string;
    assessmentTitle?: string | undefined;
    assessmentType?: AssessmentTypeEnum;
    courseToken?: string | undefined;
    lectureToken?: string | undefined;
    ownerTitle?: string | undefined;
    dueDate?: Date | undefined;
    timeLimitMinutes?: number | undefined;
    maxScore?: number;
    submittedAt?: Date | undefined;
    score?: number | undefined;
    gradedAt?: Date | undefined;
    teacherComment?: string | undefined;
}

export interface AssessmentReportItemModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AssessmentReportItemModel[] | undefined;
}

export interface AssessmentSaveRequest {
    token?: string;
    assessmentType: AssessmentTypeEnum;
    courseToken?: string | undefined;
    lectureToken?: string | undefined;
    title: string;
    description?: string | undefined;
    dueDate?: Date | undefined;
    timeLimitMinutes?: number | undefined;
    autoGrade?: boolean;
    sections: AssessmentSectionSaveRequest[];
    assignedStudentTokens?: string[] | undefined;
}

export interface AssessmentSection {
    assessmentToken?: string;
    title?: string | undefined;
    description?: string | undefined;
    orderIndex?: number;
    token?: string;
    assessmentQuestions?: AssessmentQuestion[] | undefined;
    assessmentTokenNavigation?: Assessment;
}

export interface AssessmentSectionModel {
    id: string;
    title?: string | undefined;
    description?: string | undefined;
    orderIndex?: number;
    questions?: AssessmentQuestionModel[] | undefined;
}

export interface AssessmentSectionSaveRequest {
    title?: string | undefined;
    description?: string | undefined;
    orderIndex?: number;
    questions: AssessmentQuestionSaveRequest[];
}

export interface AssessmentStudentModel {
    token?: string;
    name?: string | undefined;
    email?: string | undefined;
    profileUrl?: string | undefined;
}

export interface AssessmentStudentModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AssessmentStudentModel[] | undefined;
}

export interface AssessmentSubmission {
    token?: string;
    assessmentToken?: string;
    studentToken?: string;
    submittedAt?: Date;
    modifiedAt?: Date | undefined;
    score?: number | undefined;
    gradedAt?: Date | undefined;
    gradedBy?: string | undefined;
    teacherComment?: string | undefined;
    assessmentSubmissionAnswers?: AssessmentSubmissionAnswer[] | undefined;
    assessmentTokenNavigation?: Assessment;
    gradedByNavigation?: User;
    studentTokenNavigation?: User;
}

export interface AssessmentSubmissionAnswer {
    submissionToken?: string;
    answerText?: string | undefined;
    fileUrl?: string | undefined;
    isCorrect?: boolean | undefined;
    pointsAwarded?: number | undefined;
    token?: string;
    questionToken?: string;
    choiceToken?: string | undefined;
    matchLeftPairToken?: string | undefined;
    matchSelectedRightPairToken?: string | undefined;
    choiceTokenNavigation?: AssessmentQuestionChoice;
    matchLeftPairTokenNavigation?: AssessmentQuestionMatchPair;
    matchSelectedRightPairTokenNavigation?: AssessmentQuestionMatchPair;
    questionTokenNavigation?: AssessmentQuestion;
    submissionTokenNavigation?: AssessmentSubmission;
}

export interface AssessmentSubmissionModel {
    token: string;
    assessmentToken: string;
    studentToken: string;
    student?: UserModel;
    submittedAt?: Date;
    modifiedAt?: Date | undefined;
    score?: number | undefined;
    gradedAt?: Date | undefined;
    gradedBy?: string | undefined;
    teacherComment?: string | undefined;
    answers?: AssessmentAnswerModel[] | undefined;
}

export interface AssessmentSubmissionModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AssessmentSubmissionModel[] | undefined;
}

export interface AssessmentSubmissionModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: AssessmentSubmissionModel;
}

export enum AssessmentTypeEnum {
    Homework = 0,
    Exam = 1,
}

export interface BooleanRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: boolean;
}

export interface BulkPaymentSaveRequest {
    payments: PaymentSaveRequest[];
}

export interface Category {
    token?: string;
    categoryName?: string | undefined;
    courses?: Course[] | undefined;
}

export interface CategoryModel {
    token: string;
    categoryName: string;
}

export interface Certificate {
    token?: string;
    studentToken?: string;
    courseToken?: string;
    issuedBy?: string;
    issueDate?: Date;
    createDate?: Date;
    courseTokenNavigation?: Course;
    issuedByNavigation?: User;
    studentTokenNavigation?: User;
}

export interface CertificateModel {
    token: string;
    studentToken?: string;
    studentName?: string | undefined;
    studentProfileUrl?: string | undefined;
    courseToken?: string;
    courseTitle?: string | undefined;
    issuedByName?: string | undefined;
    issueDate?: Date;
    certificateNumber?: string | undefined;
}

export interface CertificateModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: CertificateModel[] | undefined;
}

export interface CertificateModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: CertificateModel;
}

export interface ChildDashboardSummary {
    childToken?: string;
    name?: string | undefined;
    profileUrl?: string | undefined;
    email?: string | undefined;
    totalPaid?: number;
    currencySymbol?: string | undefined;
    currencyCode?: string | undefined;
    paymentsCount?: number;
    enrolledLecturesCount?: number;
    upcomingLecturesCount?: number;
    nextLecture?: LectureSummaryModel;
}

export interface ConfirmPhoneChangeRequest {
    phoneNumber: string;
    code: string;
}

export interface ContactFormRequest {
    name: string;
    email: string;
    subject: string;
    message: string;
}

export interface Conversation {
    token?: string;
    user1Token?: string;
    user2Token?: string;
    lastMessageDate?: Date | undefined;
    createDate?: Date;
    messages?: Message[] | undefined;
    user1TokenNavigation?: User;
    user2TokenNavigation?: User;
}

export interface ConversationDto {
    token?: string;
    otherUserToken?: string;
    otherUserName?: string | undefined;
    otherUserAvatar?: string | undefined;
    lastMessageBody?: string | undefined;
    lastMessageDate?: Date | undefined;
    unreadCount?: number;
}

export interface Country {
    countryCode?: string | undefined;
    countryName?: string | undefined;
    currencyCode?: string | undefined;
    currencyCodeNavigation?: Currency;
    users?: User[] | undefined;
}

export interface CountryModel {
    countryCode: string;
    countryName: string;
    currencyCode?: string | undefined;
}

export interface Course {
    token?: string;
    title?: string | undefined;
    ownerToken?: string;
    academyToken?: string | undefined;
    imageUrl?: string | undefined;
    categoryToken?: string | undefined;
    languageToken?: string;
    level?: string | undefined;
    isActive?: boolean;
    introVideoUrl?: string | undefined;
    pdfUrl?: string | undefined;
    description?: string | undefined;
    createdBy?: string;
    modifyedBy?: string;
    createDate?: Date;
    modifyDate?: Date;
    academyTokenNavigation?: Academy;
    assessments?: Assessment[] | undefined;
    categoryTokenNavigation?: Category;
    certificates?: Certificate[] | undefined;
    createdByNavigation?: User;
    languageTokenNavigation?: Language;
    lectures?: Lecture[] | undefined;
    modifyedByNavigation?: User;
    ownerTokenNavigation?: User;
    questionBankItems?: QuestionBankItem[] | undefined;
    userTokens?: User[] | undefined;
}

export interface CourseBasicModel {
    token: string;
    title: string;
    academyToken?: string | undefined;
    ownerToken?: string;
    imageUrl?: string | undefined;
    categoryToken: string;
    categoryName?: string | undefined;
    description?: string | undefined;
}

export interface CourseEnrollmentItem {
    courseToken?: string;
    courseTitle?: string | undefined;
    tutorName?: string | undefined;
    enrolledCount?: number;
    lectureCount?: number;
}

export interface CourseGraphModel {
    token: string;
    title: string;
    academyToken?: string | undefined;
    ownerToken?: string;
    imageUrl?: string | undefined;
    categoryToken: string;
    categoryName?: string | undefined;
    description?: string | undefined;
    ownerProfileUrl?: string | undefined;
    ownerName?: string | undefined;
    owner: TutorSummaryModel;
    tutors: TutorSummaryModel[];
    lecturesCount?: number | undefined;
    rating?: number | undefined;
    ratingCount?: number;
    language?: string | undefined;
    level: string;
    isMember?: boolean | undefined;
    completePer?: number | undefined;
    isFavorite?: boolean;
    isActive: boolean;
    introVideoUrl?: string | undefined;
    pdfUrl?: string | undefined;
    lectureEnrollments?: MemberEnrollmentModel[] | undefined;
    languageToken: string;
    lectures?: LectureSummaryModel[] | undefined;
}

export interface CourseGraphModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: CourseGraphModel;
}

export interface CourseSaveRequest {
    token: string;
    title: string;
    ownerToken?: string;
    academyToken?: string | undefined;
    imageUrl?: string | undefined;
    imageFile?: string | undefined;
    categoryToken: string;
    languageToken: string;
    level?: string | undefined;
    isActive: boolean;
    introVideoUrl?: string | undefined;
    introVideoFile?: string | undefined;
    isCurrentUserAuthor?: boolean;
    createdBy?: string;
    modifyedBy?: string;
    pdfUrl?: string | undefined;
    pdfFile?: string | undefined;
    description: string;
    lectures?: LectureSummaryModel[] | undefined;
}

export interface CourseSummaryModel {
    token: string;
    title: string;
    academyToken?: string | undefined;
    ownerToken?: string;
    imageUrl?: string | undefined;
    categoryToken: string;
    categoryName?: string | undefined;
    description?: string | undefined;
    ownerProfileUrl?: string | undefined;
    ownerName?: string | undefined;
    owner: TutorSummaryModel;
    tutors: TutorSummaryModel[];
    lecturesCount?: number | undefined;
    rating?: number | undefined;
    ratingCount?: number;
    language?: string | undefined;
    level: string;
    isMember?: boolean | undefined;
    completePer?: number | undefined;
    isFavorite?: boolean;
    isActive: boolean;
}

export interface CreateChildRequest {
    name?: string | undefined;
    email?: string | undefined;
    dateOfBirth?: Date | undefined;
    educationLevel?: string | undefined;
    password?: string | undefined;
}

export interface CreateInvoiceRequest {
    amount: number;
    currencyCode: string;
    note?: string | undefined;
    paypalRecipientToken?: string | undefined;
}

export interface Currency {
    currencyCode?: string | undefined;
    currencyName?: string | undefined;
    symbol?: string | undefined;
    supportPayPal?: boolean;
    countries?: Country[] | undefined;
    invoices?: Invoice[] | undefined;
    lectures?: Lecture[] | undefined;
    payments?: Payment[] | undefined;
    subscriptionPlanPricings?: SubscriptionPlanPricing[] | undefined;
    users?: User[] | undefined;
}

export interface CurrencyBalanceModel {
    currencyCode?: string | undefined;
    symbol?: string | undefined;
    balance?: number;
}

export interface CurrencyModel {
    code: string;
    symbol: string;
    name: string;
    supportPayPal?: boolean;
}

export interface CurrencyRecommendationModel {
    currencyCode?: string | undefined;
    currencyName?: string | undefined;
    symbol?: string | undefined;
    supportPayPal?: boolean;
}

export interface DashBoardSummaryModel {
    favouriteCount?: number | undefined;
    followingCount?: number | undefined;
    ownCoursesCount?: number | undefined;
    participatedLecturesCount?: number | undefined;
    subscriptedLecturesCount?: number | undefined;
    myLecturesCount?: number | undefined;
    pendingJoinRequestsCount?: number | undefined;
    examsPendingCount?: number | undefined;
}

export interface DashboardSummaryDetailModel {
    balance?: PaymentBalanceSummary;
    nextLectures?: LectureSummaryModel[] | undefined;
    upcomingLecturesCount?: number;
    pendingJoinRequestsCount?: number;
    pendingPaymentsCount?: number;
    recentPayments?: PaymentModel[] | undefined;
    childrenSummary?: ChildDashboardSummary[] | undefined;
}

export interface Discussion {
    id?: number;
    lectureToken?: string;
    memberToken?: string;
    message?: string | undefined;
    createdAt?: Date;
    lectureTokenNavigation?: Lecture;
}

export interface DiscussionModel {
    token: string;
    text: string;
    date: Date;
    user: UserModel;
    replies?: DiscussionModel[] | undefined;
}

export enum EnrollmentModeEnum {
    AutoApprove = 0,
    ManualApprove = 1,
    RequirePayment = 2,
    Private = 3,
}

export interface Feedback {
    token?: string;
    userToken?: string;
    rating?: number;
    message?: string | undefined;
    createdAt?: Date;
    userTokenNavigation?: User;
}

export interface FeedbackDto {
    token?: string;
    rating?: number;
    message?: string | undefined;
    createdAt?: Date;
    userToken?: string;
    userName?: string | undefined;
    userAvatar?: string | undefined;
}

export interface FeedbackDtoListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: FeedbackDto[] | undefined;
}

export interface FeedbackDtoRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: FeedbackDto;
}

export interface FeedbackStatsDto {
    count?: number;
    averageRating?: number;
}

export interface FeedbackStatsDtoRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: FeedbackStatsDto;
}

export interface ForgotPasswordRequest {
    email: string;
}

export interface GoogleLoginRequest {
    idToken: string;
}

export interface GradeAssessmentSubmissionRequest {
    grades: AssessmentQuestionGradeRequest[];
    teacherComment?: string | undefined;
}

export enum InvitationDirectionEnum {
    MyInvite = 0,
    Incoming = 1,
}

export interface Invoice {
    token?: string;
    lectureToken?: string;
    studentToken?: string;
    createdBy?: string;
    amount?: number;
    currencyCode?: string | undefined;
    commissionPercentage?: number;
    note?: string | undefined;
    status?: number;
    paypalOrderId?: string | undefined;
    paidAt?: Date | undefined;
    createDate?: Date;
    modifyDate?: Date;
    paypalRecipientToken?: string | undefined;
    createdByNavigation?: User;
    currencyCodeNavigation?: Currency;
    lectureEnrollment?: LectureEnrollment;
    lectureTokenNavigation?: Lecture;
    paypalRecipientTokenNavigation?: User;
    studentTokenNavigation?: User;
}

export interface InvoiceModel {
    token?: string;
    lectureToken?: string;
    lectureTitle?: string | undefined;
    studentToken?: string;
    studentName?: string | undefined;
    createdBy?: string;
    tutorName?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    note?: string | undefined;
    status?: InvoiceStatusEnum;
    paypalOrderId?: string | undefined;
    paypalRecipientToken?: string | undefined;
    paypalRecipientName?: string | undefined;
    paidAt?: Date | undefined;
    createDate?: Date;
}

export interface InvoiceModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: InvoiceModel[] | undefined;
}

export interface InvoiceModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: InvoiceModel;
}

export enum InvoiceStatusEnum {
    Pending = 0,
    Paid = 1,
    Cancelled = 2,
}

export interface IssueCertificateRequest {
    studentToken: string;
    courseToken: string;
}

export enum ItemTypeEnum {
    NONE = 0,
    Lecture = 1,
    Tutor = 2,
    Course = 3,
}

export enum JoinRequestType {
    Incoming = 1,
    MyRequests = 2,
    MyInvitations = 3,
    All = 4,
    Pending = 5,
}

export interface Language {
    token?: string;
    languageName?: string | undefined;
    courses?: Course[] | undefined;
    tutorTokens?: Tutor[] | undefined;
}

export interface LanguageModel {
    token: string;
    languageName: string;
}

export interface Lecture {
    token?: string;
    title?: string | undefined;
    lecType?: number;
    courseToken?: string;
    imageUrl?: string | undefined;
    introVideoUrl?: string | undefined;
    authorToken?: string;
    price?: number | undefined;
    currencyCode?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    duration?: string | undefined;
    description?: string | undefined;
    videoUrl?: string | undefined;
    pdfUrl?: string | undefined;
    curriculum?: string | undefined;
    meetingUrl?: string | undefined;
    meetingPassword?: string | undefined;
    liveSessionType?: number;
    maxEnrollmentsCount?: number | undefined;
    tags?: string | undefined;
    createDate?: Date;
    modifyDate?: Date;
    createdBy?: string;
    modifyedBy?: string;
    enrollmentMode?: number;
    paymentMode?: number | undefined;
    paypalRecipientToken?: string | undefined;
    assessments?: Assessment[] | undefined;
    authorTokenNavigation?: User;
    courseTokenNavigation?: Course;
    createdByNavigation?: User;
    currencyCodeNavigation?: Currency;
    discussions?: Discussion[] | undefined;
    invoices?: Invoice[] | undefined;
    lectureEnrollments?: LectureEnrollment[] | undefined;
    lecturePaymentOrderItems?: LecturePaymentOrderItem[] | undefined;
    lectureSmsReminders?: LectureSmsReminder[] | undefined;
    modifyedByNavigation?: User;
    paypalRecipientTokenNavigation?: User;
    rates?: Rate[] | undefined;
    reviews?: Review[] | undefined;
    userTokens?: User[] | undefined;
}

export interface LectureEnrollment {
    lectureToken?: string;
    memberToken?: string;
    roleId?: number;
    requestSource?: number;
    requestDate?: Date;
    adminToken?: string | undefined;
    memberDecisionDate?: Date | undefined;
    isMemberApprove?: boolean | undefined;
    isAdminApprove?: boolean | undefined;
    adminDecisionDate?: Date | undefined;
    progressPercent?: number | undefined;
    lastPositionSeconds?: number | undefined;
    isCompleted?: boolean;
    completedAt?: Date | undefined;
    totalAttendanceMinutes?: number | undefined;
    lastJoinedAt?: Date | undefined;
    lastLeftAt?: Date | undefined;
    adminTokenNavigation?: User;
    invoices?: Invoice[] | undefined;
    lectureTokenNavigation?: Lecture;
    memberTokenNavigation?: User;
    payments?: Payment[] | undefined;
    tutorFeedbacks?: TutorFeedback[] | undefined;
}

export interface LectureGraphModel {
    token: string;
    title: string;
    lecType: LectureType;
    courseToken: string;
    imageUrl?: string | undefined;
    introVideoUrl?: string | undefined;
    authorToken?: string;
    price: number;
    currencyCode: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    duration?: string | undefined;
    description?: string | undefined;
    maxEnrollmentsCount?: number | undefined;
    enrollmentMode?: EnrollmentModeEnum;
    paymentMode?: PaymentModeEnum;
    liveSessionType?: LiveSessionTypeEnum;
    courseOwnerToken?: string;
    courseOwnerProfileUrl?: string | undefined;
    courseOwnerName?: string | undefined;
    lectureAuthorProfileUrl?: string | undefined;
    lectureAuthorName?: string | undefined;
    lectureAuthorUserType?: UserTypeEnum;
    isLectureAdmin?: boolean;
    isEditable?: boolean;
    course?: CourseBasicModel;
    rating: number;
    yourRating?: number | undefined;
    joinStatus?: LectureJoinStatusEnum;
    readonly joinStatusText?: string | undefined;
    isFavorite?: boolean;
    favoriteCount?: number;
    tutors?: UserModel[] | undefined;
    tags?: string[] | undefined;
    reviews?: ReviewModel[] | undefined;
    discussions?: DiscussionModel[] | undefined;
    ratingCount?: number | undefined;
    videoUrl?: string | undefined;
    pdfUrl?: string | undefined;
    enrollmentsCount?: number | undefined;
    languageName?: string | undefined;
    paypalRecipientToken?: string | undefined;
    author?: TutorSummaryModel;
    enrollments: MemberEnrollmentModel[];
    curriculum?: string | undefined;
    meetingUrl?: string | undefined;
    meetingPassword?: string | undefined;
}

export interface LectureGraphModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: LectureGraphModel;
}

export enum LectureJoinStatusEnum {
    None = 0,
    Owner = 1,
    Student = 2,
    Tutor = 3,
    StudentRequestPending = 4,
    TutorRequestPending = 5,
    StudentInvitationPending = 6,
    TutorInvitationPending = 7,
    StudentRejected = 8,
    TutorRejected = 9,
}

export interface LecturePaymentOrder {
    token?: string;
    orderId?: string | undefined;
    studentToken?: string;
    status?: string | undefined;
    createDate?: Date;
    modifyDate?: Date;
    lecturePaymentOrderItems?: LecturePaymentOrderItem[] | undefined;
    studentTokenNavigation?: User;
}

export interface LecturePaymentOrderItem {
    token?: string;
    orderToken?: string;
    lectureToken?: string;
    paypalRecipientToken?: string;
    commissionPercentage?: number;
    amount?: number;
    currencyCode?: string | undefined;
    lectureTokenNavigation?: Lecture;
    orderTokenNavigation?: LecturePaymentOrder;
    paypalRecipientTokenNavigation?: User;
}

export interface LectureProgressModel {
    lectureToken: string;
    studentToken: string;
    progressPercent?: number | undefined;
    lastPositionSeconds?: number | undefined;
    isCompleted?: boolean;
    completedAt?: Date | undefined;
    totalAttendanceMinutes?: number | undefined;
    lastJoinedAt?: Date | undefined;
    lastLeftAt?: Date | undefined;
}

export interface LectureProgressModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: LectureProgressModel;
}

export interface LectureRatingRequst {
    rate?: number;
    lectureId?: string | undefined;
}

export interface LectureSaveRequest {
    token: string;
    title: string;
    lecType: LectureType;
    courseToken: string;
    imageUrl?: string | undefined;
    introVideoUrl?: string | undefined;
    authorToken?: string;
    price?: number | undefined;
    currencyCode?: string | undefined;
    sessionDate?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    duration?: string | undefined;
    description?: string | undefined;
    paypalRecipientToken?: string | undefined;
    videoUrl?: string | undefined;
    pdfUrl?: string | undefined;
    curriculum?: string | undefined;
    enrollmentMode?: EnrollmentModeEnum;
    paymentMode?: PaymentModeEnum;
    meetingUrl?: string | undefined;
    meetingPassword?: string | undefined;
    liveSessionType?: LiveSessionTypeEnum;
    maxEnrollmentsCount?: number | undefined;
    isEditable?: boolean;
    isCurrentUserAuthor?: boolean;
    createdBy?: string;
    modifyedBy?: string;
    tags?: string[] | undefined;
}

export interface LectureSmsReminder {
    lectureToken?: string;
    userToken?: string;
    sentAt?: Date;
    lectureTokenNavigation?: Lecture;
    userTokenNavigation?: User;
}

export interface LectureSummaryModel {
    token: string;
    title: string;
    lecType: LectureType;
    courseToken: string;
    imageUrl?: string | undefined;
    introVideoUrl?: string | undefined;
    authorToken?: string;
    price: number;
    currencyCode: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    duration?: string | undefined;
    description?: string | undefined;
    maxEnrollmentsCount?: number | undefined;
    enrollmentMode?: EnrollmentModeEnum;
    paymentMode?: PaymentModeEnum;
    liveSessionType?: LiveSessionTypeEnum;
    courseOwnerToken?: string;
    courseOwnerProfileUrl?: string | undefined;
    courseOwnerName?: string | undefined;
    lectureAuthorProfileUrl?: string | undefined;
    lectureAuthorName?: string | undefined;
    lectureAuthorUserType?: UserTypeEnum;
    isLectureAdmin?: boolean;
    isEditable?: boolean;
    course?: CourseBasicModel;
    rating: number;
    yourRating?: number | undefined;
    joinStatus?: LectureJoinStatusEnum;
    readonly joinStatusText?: string | undefined;
    isFavorite?: boolean;
    favoriteCount?: number;
    tutors?: UserModel[] | undefined;
    tags?: string[] | undefined;
    reviews?: ReviewModel[] | undefined;
    discussions?: DiscussionModel[] | undefined;
    ratingCount?: number | undefined;
    videoUrl?: string | undefined;
    pdfUrl?: string | undefined;
    enrollmentsCount?: number | undefined;
    languageName?: string | undefined;
    paypalRecipientToken?: string | undefined;
}

export enum LectureType {
    Video = 0,
    LiveSession = 1,
    Document = 2,
}

export interface LedgerTransactionModel {
    token?: string;
    type?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    status?: string | undefined;
    date?: Date;
    note?: string | undefined;
}

export interface LedgerTransactionModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: LedgerTransactionModel[] | undefined;
}

export interface LinkChildRequest {
    email?: string | undefined;
}

export enum LiveSessionTypeEnum {
    ExternalUrl = 0,
    Agora = 1,
}

export interface LoginModel {
    email?: string | undefined;
    password?: string | undefined;
}

export interface MarketingEmailRequest {
    recipients?: string[] | undefined;
    subject?: string | undefined;
    html?: string | undefined;
}

export interface MarketingEmailResult {
    sent?: number;
    failed?: number;
    invalid?: string[] | undefined;
}

export interface MarketingEmailResultRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: MarketingEmailResult;
}

export interface MarketingWhatsAppRequest {
    recipients?: string[] | undefined;
    message?: string | undefined;
}

export interface MarketingWhatsAppResult {
    sent?: number;
    failed?: number;
    invalid?: string[] | undefined;
}

export interface MarketingWhatsAppResultRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: MarketingWhatsAppResult;
}

export interface MemberBalanceModel {
    studentToken?: string;
    balances?: CurrencyBalanceModel[] | undefined;
}

export interface MemberBalanceModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: MemberBalanceModel[] | undefined;
}

export interface MemberEnrollmentModel {
    lectureToken: string;
    memberToken: string;
    lecture?: LectureSummaryModel;
    roleId: UserTypeEnum;
    member: UserModel;
    adminToken?: string | undefined;
    admin?: UserModel;
    requestDate?: Date;
    decisionDate?: Date | undefined;
    memberDecisionDate?: Date | undefined;
    adminDecisionDate?: Date | undefined;
    isAdminApprove?: boolean | undefined;
    isMemberApprove?: boolean | undefined;
    requestSource?: UserTypeEnum;
    requestSourceText?: string | undefined;
    memberProfileUrl?: string | undefined;
    memberName?: string | undefined;
    memberEmail?: string | undefined;
    lectureTitle?: string | undefined;
    courseTitle?: string | undefined;
    direction?: InvitationDirectionEnum;
    readonly statusLabel?: string | undefined;
}

export interface MemberEnrollmentModelPagedResult {
    items?: MemberEnrollmentModel[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
    readonly hasMore?: boolean;
}

export interface MemberEnrollmentModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: MemberEnrollmentModel;
}

export interface Message {
    token?: string;
    conversationToken?: string;
    senderToken?: string;
    body?: string | undefined;
    sentAt?: Date;
    isRead?: boolean;
    conversationTokenNavigation?: Conversation;
    senderTokenNavigation?: User;
}

export interface MessageDto {
    token?: string;
    senderToken?: string;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    body?: string | undefined;
    sentAt?: Date;
    isRead?: boolean;
    isOwn?: boolean;
}

export interface MonthlyRevenueItem {
    monthLabel?: string | undefined;
    amount?: number;
}

export interface MonthlyStudentsItem {
    monthLabel?: string | undefined;
    count?: number;
}

export interface Notification {
    token?: string;
    notificationType?: number;
    notifiedUser?: string;
    label?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    imgUrl?: string | undefined;
    date?: Date;
    isSeen?: boolean;
    sourceUserToken?: string | undefined;
    notifiedUserNavigation?: User;
    sourceUserTokenNavigation?: User;
}

export interface NotificationItemModel {
    token: string;
    notificationType: string;
    label: string;
    url: string;
    imgUrl: string;
    date: Date;
    isSeen: boolean;
}

export interface Parent {
    token?: string;
    parentChildren?: ParentChild[] | undefined;
    tokenNavigation?: User;
}

export interface ParentChild {
    parentToken?: string;
    childToken?: string;
    linkedAt?: Date | undefined;
    linkStatus?: number;
    respondedAt?: Date | undefined;
    childTokenNavigation?: Student;
    parentTokenNavigation?: Parent;
}

export interface ParentChildModel {
    parentToken?: string;
    childToken?: string;
    linkedAt?: Date;
    linkStatus?: ParentChildStatusEnum;
    parentName?: string | undefined;
    parentEmail?: string | undefined;
    parentProfileUrl?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    profileUrl?: string | undefined;
    dateOfBirth?: Date | undefined;
    isActive?: boolean;
    isVerified?: boolean;
    educationLevel?: string | undefined;
    enrollmentsCount?: number;
}

export interface ParentChildModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: ParentChildModel;
}

export enum ParentChildStatusEnum {
    Pending = 0,
    Accepted = 1,
    Rejected = 2,
}

export interface Payment {
    token?: string;
    lectureToken?: string;
    memberToken?: string;
    amount?: number;
    currencyCode?: string | undefined;
    paymentType?: number;
    status?: number;
    paymentDate?: Date;
    orderReference?: string | undefined;
    notes?: string | undefined;
    recordedByUserToken?: string | undefined;
    createDate?: Date;
    modifyDate?: Date;
    promoCodeToken?: string | undefined;
    discountAmount?: number | undefined;
    currencyCodeNavigation?: Currency;
    lectureEnrollment?: LectureEnrollment;
    promoCodeTokenNavigation?: PromoCode;
    recordedByUserTokenNavigation?: User;
}

export interface PaymentBalanceSummary {
    totalOutgoing?: number;
    totalIncoming?: number;
    readonly balance?: number;
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
}

export enum PaymentDirection {
    Outgoing = 0,
    Incoming = 1,
}

export enum PaymentModeEnum {
    Online = 0,
    Manual = 1,
    Both = 2,
}

export interface PaymentModel {
    token?: string;
    lectureToken?: string;
    memberToken?: string;
    memberName?: string | undefined;
    memberEmail?: string | undefined;
    memberProfileUrl?: string | undefined;
    lectureTitle?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    currencySymbol?: string | undefined;
    status?: PaymentStatusEnum;
    paymentType?: PaymentTypeEnum;
    readonly isCountedAsPaid?: boolean;
    readonly paymentStatusLabel?: string | undefined;
    paymentDate?: Date;
    orderReference?: string | undefined;
    notes?: string | undefined;
    recordedByUserToken?: string | undefined;
    recordedByName?: string | undefined;
    createDate?: Date;
    modifyDate?: Date;
    direction?: PaymentDirection;
}

export interface PaymentModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: PaymentModel[] | undefined;
}

export interface PaymentResponseMessage {
    title?: string | undefined;
    message?: string | undefined;
    redirectUrl?: string | undefined;
    paymentStatus?: PaymentStatusEnum;
    updatedAccountInfo?: AccountInfoModel;
}

export interface PaymentResponseMessageRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: PaymentResponseMessage;
}

export interface PaymentSaveRequest {
    token?: string;
    lectureToken: string;
    memberToken: string;
    amount: number;
    currencyCode: string;
    status?: PaymentStatusEnum;
    paymentType?: PaymentTypeEnum;
    paymentDate: Date;
    orderReference?: string | undefined;
    notes?: string | undefined;
}

export enum PaymentStatusEnum {
    CREATED = 0,
    SAVED = 1,
    APPROVED = 2,
    VOIDED = 3,
    COMPLETED = 4,
    PAYER_ACTION_REQUIRED = 5,
    CANCELED = 6,
    RESOURCE_NOT_FOUND = 7,
    ORDER_NOT_APPROVED = 8,
    INSTRUMENT_DECLINED = 9,
}

export enum PaymentTypeEnum {
    Manual_Paid = 1,
    Manual_Received = 2,
    Paypal_Paid = 3,
    Paypal_Received = 4,
}

export interface PayoutRequist {
    tokens?: string[] | undefined;
    forChildToken?: string | undefined;
}

export interface PaypalOrderCreationResult {
    approvalUrl?: string | undefined;
    orderId?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
}

export interface PaypalOrderCreationResultRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: PaypalOrderCreationResult;
}

export interface PaypalRecipientCandidateModel {
    token?: string;
    name?: string | undefined;
    paypalAccount?: string | undefined;
}

export interface PaypalRecipientCandidateModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: PaypalRecipientCandidateModel[] | undefined;
}

export interface PendingAssessmentModel {
    assessmentToken: string;
    title?: string | undefined;
    dueDate?: Date | undefined;
    courseToken?: string | undefined;
    courseTitle?: string | undefined;
}

export interface PendingAssessmentModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: PendingAssessmentModel[] | undefined;
}

export interface PromoCode {
    token?: string;
    code?: string | undefined;
    description?: string | undefined;
    discountType?: number;
    discountValue?: number;
    maxUses?: number | undefined;
    usedCount?: number;
    expiryDate?: Date | undefined;
    isActive?: boolean;
    createDate?: Date;
    modifyDate?: Date;
    payments?: Payment[] | undefined;
    userSubscriptions?: UserSubscription[] | undefined;
}

export interface PromoCodeIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: PromoCode[] | undefined;
}

export interface PromoCodeRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: PromoCode;
}

export interface QuestionBankChoiceModel {
    id?: number;
    choiceText?: string | undefined;
    isCorrect?: boolean;
    orderIndex?: number;
}

export interface QuestionBankChoiceSaveRequest {
    choiceText: string;
    isCorrect?: boolean;
    orderIndex?: number;
}

export interface QuestionBankItem {
    token?: string;
    courseToken?: string;
    questionType?: number;
    questionText?: string | undefined;
    topic?: string | undefined;
    autoGrade?: boolean | undefined;
    correctAnswerText?: string | undefined;
    createdBy?: string;
    createDate?: Date;
    modifyDate?: Date;
    courseTokenNavigation?: Course;
    createdByNavigation?: User;
    questionBankItemChoices?: QuestionBankItemChoice[] | undefined;
    questionBankItemMatchPairs?: QuestionBankItemMatchPair[] | undefined;
}

export interface QuestionBankItemChoice {
    id?: number;
    questionBankItemToken?: string;
    choiceText?: string | undefined;
    isCorrect?: boolean;
    orderIndex?: number;
    questionBankItemTokenNavigation?: QuestionBankItem;
}

export interface QuestionBankItemMatchPair {
    id?: number;
    questionBankItemToken?: string;
    leftText?: string | undefined;
    rightText?: string | undefined;
    orderIndex?: number;
    questionBankItemTokenNavigation?: QuestionBankItem;
}

export interface QuestionBankItemModel {
    token?: string;
    courseToken?: string;
    questionType?: AssessmentQuestionTypeEnum;
    questionText?: string | undefined;
    topic?: string | undefined;
    autoGrade?: boolean | undefined;
    correctAnswerText?: string | undefined;
    createDate?: Date;
    choices?: QuestionBankChoiceModel[] | undefined;
    matchPairs?: QuestionBankMatchPairModel[] | undefined;
}

export interface QuestionBankItemModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: QuestionBankItemModel[] | undefined;
}

export interface QuestionBankItemModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: QuestionBankItemModel;
}

export interface QuestionBankMatchPairModel {
    id?: number;
    leftText?: string | undefined;
    rightText?: string | undefined;
    orderIndex?: number;
}

export interface QuestionBankMatchPairSaveRequest {
    leftText: string;
    rightText: string;
    orderIndex?: number;
}

export interface QuestionBankSaveRequest {
    token?: string;
    courseToken: string;
    questionType: number;
    questionText: string;
    topic?: string | undefined;
    autoGrade?: boolean | undefined;
    correctAnswerText?: string | undefined;
    choices?: QuestionBankChoiceSaveRequest[] | undefined;
    matchPairs?: QuestionBankMatchPairSaveRequest[] | undefined;
}

export interface Rate {
    lectureToken?: string;
    userToken?: string;
    rate1?: number;
    lectureTokenNavigation?: Lecture;
    userTokenNavigation?: User;
}

export interface RegisterModel {
    token?: string;
    name?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    countryCode?: string | undefined;
    dob?: Date | undefined;
    title?: string | undefined;
    biography?: string | undefined;
    educationLevel?: string | undefined;
    profileUrl?: string | undefined;
    userType?: UserTypeEnum;
    phoneNumber?: string | undefined;
    phoneVerificationProof?: string | undefined;
}

export interface ResendVerificationRequest {
    email: string;
}

export interface ResetPasswordRequest {
    token: string;
    newPassword: string;
}

export interface Review {
    token?: string;
    lectureToken?: string;
    memberToken?: string;
    comment?: string | undefined;
    rating?: number | undefined;
    createdAt?: Date;
    lectureTokenNavigation?: Lecture;
    memberTokenNavigation?: User;
}

export interface ReviewModel {
    token: string;
    lectureToken: string;
    memberToken: string;
    comment?: string | undefined;
    rating?: number | undefined;
    createdAt?: Date;
    member?: UserModel;
}

export interface ReviewModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: ReviewModel;
}

export interface SaveStudentRequest {
    student?: StudentModel;
}

export interface SearchResultItemModel {
    course?: CourseSummaryModel;
    tutor?: TutorSummaryModel;
    lecture?: LectureSummaryModel;
}

export interface SendMessageRequest {
    body?: string | undefined;
}

export interface SendPhoneChangeOtpRequest {
    phoneNumber: string;
}

export interface SendRegistrationPhoneOtpRequest {
    phoneNumber: string;
}

export interface SetChildPasswordRequest {
    newPassword: string;
}

export interface SiteStatusModel {
    isLiveApp?: boolean;
    enableAgora?: boolean;
    paypalCommissionPercentage?: number;
}

export interface StringRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: string | undefined;
}

export interface Student {
    token?: string;
    educationLevel?: string | undefined;
    parentChildren?: ParentChild[] | undefined;
    tokenNavigation?: User;
}

export interface StudentModel {
    token: string;
    email: string;
    name: string;
    title?: string | undefined;
    profileUrl?: string | undefined;
    countryCode: string;
    currencyCode: string;
    dob: Date;
    paypalAccount?: string | undefined;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    userType: UserTypeEnum;
    isActive: boolean;
    countryName: string;
    currencyName: string;
    currencySymbol: string;
    isVerified?: boolean | undefined;
    educationLevel?: string | undefined;
}

export interface StudentModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: StudentModel;
}

export interface StudentSummaryModel {
    token: string;
    email: string;
    name: string;
    title?: string | undefined;
    profileUrl?: string | undefined;
    countryCode: string;
    currencyCode: string;
    dob: Date;
    paypalAccount?: string | undefined;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    userType: UserTypeEnum;
    isActive: boolean;
    countryName: string;
    currencyName: string;
    currencySymbol: string;
    isVerified?: boolean | undefined;
    educationLevel?: string | undefined;
}

export interface SubmitFeedbackRequest {
    rating?: number;
    message?: string | undefined;
}

export interface SubscriptionCartItem {
    planToken: string;
    planName?: string | undefined;
    currencyCode: string;
    symbol?: string | undefined;
    price: number;
    periodDays: number;
    unitCount: number;
}

export interface SubscriptionEntryModel {
    token?: string;
    lectureToken?: string;
    lectureTitle?: string | undefined;
    studentToken?: string;
    studentName?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    status?: string | undefined;
    date?: Date;
}

export interface SubscriptionEntryModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: SubscriptionEntryModel[] | undefined;
}

export interface SubscriptionPlan {
    token?: string;
    planName?: string | undefined;
    description?: string | undefined;
    periodDays?: number;
    billingCycle?: string | undefined;
    maxCourses?: number | undefined;
    maxStudents?: number | undefined;
    maxLectures?: number | undefined;
    userType?: number;
    maxTutors?: number | undefined;
    subscriptionPlanPricings?: SubscriptionPlanPricing[] | undefined;
}

export interface SubscriptionPlanFullPricingModel {
    currencyCode?: string | undefined;
    currencyName?: string | undefined;
    symbol?: string | undefined;
    planToken?: string;
    price?: number;
    planName?: string | undefined;
    description?: string | undefined;
    periodDays?: number;
    billingCycle?: string | undefined;
    userType?: number;
    maxCourses?: number | undefined;
    maxStudents?: number | undefined;
    maxLectures?: number | undefined;
    maxTutors?: number | undefined;
}

export interface SubscriptionPlanPricing {
    currencyCode?: string | undefined;
    planToken?: string;
    price?: number;
    currencyCodeNavigation?: Currency;
    planTokenNavigation?: SubscriptionPlan;
    userSubscriptions?: UserSubscription[] | undefined;
}

export interface TransactionModel {
    token: string;
    transactionDate: Date;
    amount: number;
    type: string;
    description: string;
    currencyCode: string;
    paypalId?: string | undefined;
    lectureToken?: string | undefined;
}

export interface Tutor {
    token?: string;
    biography?: string | undefined;
    title?: string | undefined;
    isVerified?: boolean;
    academyToken?: string | undefined;
    verificationIdFrontUrl?: string | undefined;
    verificationIdBackUrl?: string | undefined;
    verificationIdType?: number | undefined;
    tags?: string | undefined;
    verificationSelfieUrl?: string | undefined;
    verificationStatus?: number | undefined;
    verificationSubmittedDate?: Date | undefined;
    verificationRejectionReason?: string | undefined;
    academyTokenNavigation?: Academy;
    tokenNavigation?: User;
    languageTokens?: Language[] | undefined;
    userTokens?: User[] | undefined;
}

export interface TutorFeedback {
    lectureToken?: string;
    tutorToken?: string;
    studentToken?: string;
    comment?: string | undefined;
    createdAt?: Date;
    modifiedAt?: Date | undefined;
    lectureEnrollment?: LectureEnrollment;
    tutorTokenNavigation?: User;
}

export interface TutorFeedbackModel {
    lectureToken: string;
    tutorToken?: string;
    studentToken: string;
    comment: string;
    createdAt?: Date;
    tutor?: UserModel;
}

export interface TutorFeedbackModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: TutorFeedbackModel[] | undefined;
}

export interface TutorFeedbackModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: TutorFeedbackModel;
}

export interface TutorModel {
    token: string;
    email: string;
    name: string;
    title?: string | undefined;
    profileUrl?: string | undefined;
    countryCode: string;
    currencyCode: string;
    dob: Date;
    paypalAccount?: string | undefined;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    userType: UserTypeEnum;
    isActive: boolean;
    countryName: string;
    currencyName: string;
    currencySymbol: string;
    isVerified?: boolean | undefined;
    rating: number;
    biography: string;
    isFollow: boolean;
    verificationIdFrontUrl?: string | undefined;
    verificationIdBackUrl?: string | undefined;
    verificationSelfieUrl?: string | undefined;
    verificationIdType?: VerificationIdTypeEnum;
    verificationStatus?: VerificationStatusEnum;
    verificationSubmittedDate?: Date | undefined;
    verificationRejectionReason?: string | undefined;
    tags?: string[] | undefined;
    academyProfileUrl?: string | undefined;
    academyToken?: string | undefined;
    isAcademyTutor?: boolean;
    academyName?: string | undefined;
    academyTagline?: string | undefined;
    owenCourses?: CourseBasicModel[] | undefined;
    instructedLecture?: LectureSummaryModel[] | undefined;
    languages: LanguageModel[];
    isTutorVerified: boolean;
    courses: CourseSummaryModel[];
    followers: number;
    following: number;
}

export interface TutorModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: TutorModel;
}

export interface TutorPerformanceItem {
    tutorToken?: string;
    tutorName?: string | undefined;
    profileUrl?: string | undefined;
    lectureCount?: number;
    studentCount?: number;
    averageRating?: number;
    isVerified?: boolean;
}

export interface TutorRatingItem {
    tutorName?: string | undefined;
    profileUrl?: string | undefined;
    avgRating?: number;
    ratingCount?: number;
}

export interface TutorRevenueItem {
    tutorName?: string | undefined;
    profileUrl?: string | undefined;
    totalRevenue?: number;
    paymentCount?: number;
}

export interface TutorSummaryModel {
    token: string;
    email: string;
    name: string;
    title?: string | undefined;
    profileUrl?: string | undefined;
    countryCode: string;
    currencyCode: string;
    dob: Date;
    paypalAccount?: string | undefined;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    userType: UserTypeEnum;
    isActive: boolean;
    countryName: string;
    currencyName: string;
    currencySymbol: string;
    isVerified?: boolean | undefined;
    rating: number;
    biography: string;
    isFollow: boolean;
    verificationIdFrontUrl?: string | undefined;
    verificationIdBackUrl?: string | undefined;
    verificationSelfieUrl?: string | undefined;
    verificationIdType?: VerificationIdTypeEnum;
    verificationStatus?: VerificationStatusEnum;
    verificationSubmittedDate?: Date | undefined;
    verificationRejectionReason?: string | undefined;
    tags?: string[] | undefined;
    academyProfileUrl?: string | undefined;
    academyToken?: string | undefined;
    isAcademyTutor?: boolean;
    academyName?: string | undefined;
    academyTagline?: string | undefined;
    owenCourses?: CourseBasicModel[] | undefined;
    instructedLecture?: LectureSummaryModel[] | undefined;
    languages: LanguageModel[];
    isTutorVerified: boolean;
}

export interface TutorSummaryModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: TutorSummaryModel[] | undefined;
}

export interface TutorSummaryModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: TutorSummaryModel;
}

export interface UpcomingLectureItem {
    lectureToken?: string;
    title?: string | undefined;
    courseTitle?: string | undefined;
    tutorName?: string | undefined;
    startDate?: Date | undefined;
    enrolled?: number;
    maxEnrollments?: number | undefined;
}

export interface UpdateProgressRequest {
    lectureToken: string;
    positionSeconds?: number | undefined;
    progressPercent?: number | undefined;
    markCompleted?: boolean;
}

export interface User {
    token?: string;
    email?: string | undefined;
    password?: string | undefined;
    name?: string | undefined;
    profileUrl?: string | undefined;
    countryCode?: string | undefined;
    currencyCode?: string | undefined;
    dob?: Date | undefined;
    userType?: number;
    isActive?: boolean;
    isVerified?: boolean | undefined;
    paypalAccount?: string | undefined;
    verificationToken?: string | undefined;
    createDate?: Date;
    modifyDate?: Date;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    encPass?: string | undefined;
    academy?: Academy;
    assessmentAssignedStudents?: AssessmentAssignedStudent[] | undefined;
    assessmentSubmissionGradedByNavigations?: AssessmentSubmission[] | undefined;
    assessmentSubmissionStudentTokenNavigations?: AssessmentSubmission[] | undefined;
    assessments?: Assessment[] | undefined;
    certificateIssuedByNavigations?: Certificate[] | undefined;
    certificateStudentTokenNavigations?: Certificate[] | undefined;
    conversationUser1TokenNavigations?: Conversation[] | undefined;
    conversationUser2TokenNavigations?: Conversation[] | undefined;
    countryCodeNavigation?: Country;
    courseCreatedByNavigations?: Course[] | undefined;
    courseModifyedByNavigations?: Course[] | undefined;
    courseOwnerTokenNavigations?: Course[] | undefined;
    currencyCodeNavigation?: Currency;
    feedbacks?: Feedback[] | undefined;
    invoiceCreatedByNavigations?: Invoice[] | undefined;
    invoicePaypalRecipientTokenNavigations?: Invoice[] | undefined;
    invoiceStudentTokenNavigations?: Invoice[] | undefined;
    lectureAuthorTokenNavigations?: Lecture[] | undefined;
    lectureCreatedByNavigations?: Lecture[] | undefined;
    lectureEnrollmentAdminTokenNavigations?: LectureEnrollment[] | undefined;
    lectureEnrollmentMemberTokenNavigations?: LectureEnrollment[] | undefined;
    lectureModifyedByNavigations?: Lecture[] | undefined;
    lecturePaymentOrderItems?: LecturePaymentOrderItem[] | undefined;
    lecturePaymentOrders?: LecturePaymentOrder[] | undefined;
    lecturePaypalRecipientTokenNavigations?: Lecture[] | undefined;
    lectureSmsReminders?: LectureSmsReminder[] | undefined;
    messages?: Message[] | undefined;
    notificationNotifiedUserNavigations?: Notification[] | undefined;
    notificationSourceUserTokenNavigations?: Notification[] | undefined;
    parent?: Parent;
    payments?: Payment[] | undefined;
    questionBankItems?: QuestionBankItem[] | undefined;
    rates?: Rate[] | undefined;
    reviews?: Review[] | undefined;
    student?: Student;
    tutor?: Tutor;
    tutorFeedbacks?: TutorFeedback[] | undefined;
    userSetting?: UserSetting;
    userSubscriptions?: UserSubscription[] | undefined;
    voiceHelplineCalls?: VoiceHelplineCall[] | undefined;
    courseTokens?: Course[] | undefined;
    followedTutorTokens?: Tutor[] | undefined;
    lectureTokens?: Lecture[] | undefined;
}

export interface UserModel {
    token: string;
    email: string;
    name: string;
    title?: string | undefined;
    profileUrl?: string | undefined;
    countryCode: string;
    currencyCode: string;
    dob: Date;
    paypalAccount?: string | undefined;
    phoneNumber?: string | undefined;
    isPhoneVerified?: boolean;
    userType: UserTypeEnum;
    isActive: boolean;
    countryName: string;
    currencyName: string;
    currencySymbol: string;
    isVerified?: boolean | undefined;
}

export interface UserModelRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: UserModel;
}

export interface UserSetting {
    userToken?: string;
    emailLectureInvitation?: boolean;
    emailInvitationResponse?: boolean;
    emailJoinRequest?: boolean;
    emailParentInvitation?: boolean;
    emailParentLinkResponse?: boolean;
    modifyDate?: Date;
    smsLectureStarting?: boolean;
    smsLectureLeadTimeMinutes?: number;
    smsInvoiceCreated?: boolean;
    smsInvoicePaid?: boolean;
    userTokenNavigation?: User;
}

export interface UserSettingsDto {
    emailLectureInvitation?: boolean;
    emailInvitationResponse?: boolean;
    emailJoinRequest?: boolean;
    emailParentInvitation?: boolean;
    emailParentLinkResponse?: boolean;
    smsInvoiceCreated?: boolean;
    smsInvoicePaid?: boolean;
    smsLectureStarting?: boolean;
    smsLectureLeadTimeMinutes?: number;
}

export interface UserSubscription {
    userSubscriptionsToken?: string;
    userToken?: string;
    planToken?: string;
    currencyCode?: string | undefined;
    price?: number;
    orderId?: string | undefined;
    paymentStatus?: string | undefined;
    period?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    isActive?: boolean;
    createDate?: Date;
    modifyDate?: Date;
    promoCodeToken?: string | undefined;
    discountAmount?: number | undefined;
    promoCodeTokenNavigation?: PromoCode;
    subscriptionPlanPricing?: SubscriptionPlanPricing;
    userTokenNavigation?: User;
}

export interface UserSubscriptionModel {
    userSubscriptionsToken?: string;
    userToken?: string;
    planToken?: string;
    planName?: string | undefined;
    currencyCode?: string | undefined;
    price?: number;
    orderId?: string | undefined;
    paymentStatus?: string | undefined;
    period?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    createDate?: Date;
    modifyDate?: Date;
    readonly status?: string | undefined;
}

export enum UserSubscriptionStatusEnum {
    NotSubscriptionValid = 0,
    NotSubscriped = 1,
    SubscripedAboutToExpired = 2,
    Subscriped = 3,
    NotTutor = 4,
    OnTrial = 5,
}

export enum UserTypeEnum {
    Student = 0,
    Tutor = 1,
    Parent = 2,
    Academy = 3,
    Admin = 4,
}

export enum VerificationIdTypeEnum {
    NationalIDCard = 0,
    DL = 1,
    Passport = 2,
    ResidencePermit = 3,
}

export enum VerificationStatusEnum {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
}

export interface VerifyRegistrationPhoneOtpRequest {
    phoneNumber: string;
    code: string;
}

export interface VoiceCallSummaryModel {
    token?: string;
    callSid?: string | undefined;
    callerNumber?: string | undefined;
    callerName?: string | undefined;
    language?: string | undefined;
    summary?: string | undefined;
    transcript?: string | undefined;
    turnCount?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    durationSeconds?: number | undefined;
}

export interface VoiceCallSummaryModelIListRestApiResponse {
    status?: string | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
    data?: VoiceCallSummaryModel[] | undefined;
}

export interface VoiceHelplineCall {
    token?: string;
    callSid?: string | undefined;
    callerNumber?: string | undefined;
    calledNumber?: string | undefined;
    callerUserToken?: string | undefined;
    language?: string | undefined;
    summary?: string | undefined;
    transcript?: string | undefined;
    turnCount?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    createDate?: Date;
    callerUserTokenNavigation?: User;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}